<template>
  <div class="pt-0">
    <div>
      <b-row align-h="start" align-v="center">
        <b-col cols="12" class="pr-0">
          <h2 style="color: #12576e; align-items: center; display: flex">
            Produtos e Serviços:
            <small
              @click="addNewProduct()"
              style="
                color: rgb(255, 255, 255);
                font-size: small;
                padding: 3px 7px !important;
                margin-left: 10px;
                align-items: center;
                display: flex;
              "
              class="btn btn-success p-0 pl-1 pr-1"
              type="button"
              >adicionar</small
            >
            <!-- busca substitui
            <small
              @click="openImportBookingModal()"
              style="color: #fff; font-size: small"
              class="btn btn-primary p-0 pl-1 pr-1 ml-1"
              type="button"
              >importar</small
            >
            -->
          </h2>
        </b-col>
      </b-row>

      <div
        class="pr-2 pl-2 d-none d-lg-block"
        style="margin-bottom: 10px; font-weight: 600; color: #363636"
      >
        <div>
          <b-row>
            <b-col cols="4">
              <span>Nome</span>
            </b-col>

            <b-col cols="2">
              <span>Valor</span>
            </b-col>

            <b-col cols="2">
              <span>Desconto</span>
            </b-col>

            <b-col cols="2">
              <span>Total</span>
            </b-col>
            <b-col cols="1"></b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </div>
      </div>

      <div
        v-for="(product, index) in transaction.products"
        :key="index"
        class="pl-2 pr-2"
      >
        <b-card
          v-if="!product.removed"
          no-body
          border-variant="light"
          style="margin-top: 0%; margin-bottom: 1%; padding: 1%"
          footer-class="pt-1 pb-0"
          footer-bg-variant="secondary"
        >
          <b-row align-v="center" class="transaction-product-summary">
            <b-col cols="12" lg="4">
              <span
                v-if="
                  (transaction.products[index].item.type == 'Passeio' ||
                    transaction.products[index].item.type == 'Experiência') &&
                  transaction.products[index].booking.booking_code
                "
              
              >
                <a
                  target="_blank"
                  v-bind:href="`/booking-details/${transaction.products[index].booking.booking_code}`"
                  style="color: #12576e"
                  >#{{
                    `${transaction.products[index].booking.booking_code}`
                  }}</a
                >
                <span
                  v-if="
                    transaction.products[index].booking.costumer != undefined &&
                    transaction.products[index].booking.costumer.name
                  "
                  class="ml-2 font-weight-normal"
                  >|
                  {{ transaction.products[index].booking.costumer.name }}</span
                >
                <!-- <i class="fas fa-external-link-alt ml-2"></i> -->
              </span>
              <span v-else>
                <!-- {{ transaction.products[index].item.product_name }} -->
                #0000{{ index + 1 }}
              </span>
            </b-col>

            <b-col cols="12" lg="8" class="transaction-product-summary-meta">
              <span class="transaction-summary-amount font-weight-normal">
                {{
                  formatCurrency(Number(transaction.products[index].item.price))
                }}
              </span>
              <span class="transaction-summary-amount font-weight-normal">
                {{
                  product.item.isPercentage
                    ? Number(product.item.discount)
                        .toFixed(2)
                        .replace('.', ',') + '%'
                    : formatCurrency(Number(product.item.discount))
                }}
              </span>
              <span class="transaction-summary-amount font-weight-normal">
                {{ formatCurrency(getDiscountedProductPrice(index)) }}
              </span>
              <span class="transaction-summary-actions" >
                <i
                v-if="canRemoveProduct(index)"
                  @click="toggleProductCollapse(index)"
                  :class="`no ${
                    isProductCollapseOpen(index)
                      ? 'no-up-arrow'
                      : 'no-down-arrow'
                  }`"
                  style="padding: 4px; margin: 2px"
                  type="button"
                ></i>
                <i
                  v-if="canRemoveProduct(index)"
                  @click="removeProduct(index)"
                  class="no no-trash"
                  style="padding: 4px; margin: 2px; color: #d93051"
                  type="button"
                >
                </i>
                <i
                  v-else
                  class="no no-trash"
                  style="padding: 4px; margin: 2px"
                ></i>
              </span>
            </b-col>
          </b-row>
          <b-row class="transaction-product-subtitle">
            <b-col cols="12">
              <div
                v-if="
                  transaction.products[index].item.type == 'Passeio' ||
                  transaction.products[index].item.type == 'Experiência'
                "
              >
                <h5 class="font-weight-normal">
                  {{ bookingProductName(index) }}
                  <span v-if="transaction.products[index].booking.product_place"
                    >|
                    {{
                      transaction.products[index].booking.product_place
                        ? transaction.products[index].booking.product_place
                        : ''
                    }}
                  </span>
                  <span class="font-weight-normal"
                    >|
                    {{
                      formatDate(
                        transaction.products[index].booking.date,
                        'DD/MM/YY'
                      )
                    }}</span
                  >
                  <!-- <span v-if="transaction.products[index].item.product.product_name">
                    <br>
                  {{ transaction.products[index].item.product.product_name?transaction.products[index].item.product.product_name:'' }}
                  </span> -->
                </h5>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <template
              #footer
              v-if="
                transaction.products[index].item.type == 'Passeio' &&
                !product.readonly
              "
            >
              <b-row>
                <b-col cols="6" class="pl-0 pr-0">
                  <h5>Local: {{ product.booking.product_place }}</h5>
                </b-col>

                <b-col cols="2" class="pl-0 pr-0">
                  <h5>
                    Data:
                    {{
                      product.booking.date != ''
                        ? formatDate(product.booking.date, 'DD/MM/YYYY')
                        : ''
                    }}
                  </h5>
                </b-col>

                <b-col cols="2" class="pl-0 pr-0">
                  <h5>Horário: {{ product.booking.time }}</h5>
                </b-col>

                <b-col cols="2" class="pl-0 pr-0">
                  <h5>Qtd. de pessoas: {{ product.booking.people }}</h5>
                </b-col>
              </b-row>
            </template>
          </b-row>

          <b-collapse
            :id="'product_' + index"
            :visible="isProductCollapseOpen(index)"
            :accordion="'product_' + index"
            @show="onProductShow(index)"
            @hide="onProductHide(index)"
          >
            <hr width="90%" />

            <b-row align-v="center" class="transaction-product-fields">
              <b-col cols="12" md="12" lg="3">
                <b-form-group label="Produto" label-class="small">
                  <b-form-select
                    v-model="transaction.products[index].item.uuid"
                    @change="updateTransactionBooking(index, true, true)"
                    :disabled="
                      transaction.general.open === false &&
                      transaction.general.id != null
                    "
                  >
                    <template #first>
                      <b-form-select-option :value="''" disabled
                        >Selecione um produto ou serviço</b-form-select-option
                      >
                    </template>

                    <b-form-select-option-group
                      v-for="(service_type, type_index) in poisByType"
                      :label="service_type[0]"
                      :key="type_index"
                    >
                      <b-form-select-option
                        v-for="(service, service_index) in service_type[1]"
                        :key="service_index"
                        :value="service.uuid"
                      >
                        {{ service.product_name }}
                      </b-form-select-option>
                    </b-form-select-option-group>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12" lg="3">
                <b-form-group label="Valor" label-class="small">
                  <CurrencyBaseInput
                    v-model="transaction.products[index].item.price"
                    :modelValue="
                      transaction.products[index].item.price === ''
                        ? ''
                        : Number(transaction.products[index].item.price)
                    "
                    allow-empty
                    :options="currencyOptions"
                    @change="updateProductsValue(index)"
                    @keyup="
                      updateNestedValue(
                        'products',
                        index,
                        'item',
                        'price',
                        $event
                      )
                    "
                    placeholder="R$ 0,00"
                    :disabled="
                      transaction.general.open === false &&
                      transaction.general.id != null
                    "
                    :isPercentage="false"
                  >
                  </CurrencyBaseInput>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="7" md="7" lg="6">
                <b-row align-v="center" align-h="between">
                  <b-col class="pb-0">
                    <b-form-group
                      :label="discountTypeLabel(transaction.products[index])"
                      label-class="small"
                    >
                      <b-form-select
                        :value="productDiscountType(transaction.products[index])"
                        @change="onProductDiscountTypeChange(index, $event)"
                        :disabled="
                          transaction.general.open === false &&
                          transaction.general.id != null
                        "
                        size="small"
                      >
                        <b-form-select-option
                          v-for="(discount, discount_index) in discountsType"
                          :value="discount.value"
                          :key="discount_index"
                        >
                          {{ discount.label }}
                        </b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col >
                    <b-form-group label="Desconto" label-class="small">
                      <div class="discount-value-field">
                        <CurrencyBaseInput
                          class="discount-value-input"
                          :ref="'discountInput' + index"
                          :key="`discount-${index}-${transaction.products[index].item.isPercentage}`"
                          v-model="transaction.products[index].item.discount"
                          :disabled="
                            productDiscountType(transaction.products[index]) ===
                              'none' ||
                            transaction.products[index].item.price == 0 ||
                            (transaction.general.open === false &&
                              transaction.general.id != null)
                          "
                          :modelValue="
                            Number(transaction.products[index].item.discount)
                          "
                          @change="updateProductsDiscount(index)"
                          @blur.native="onDiscountValueBlur(index)"
                          :isDiscount="true"
                          :options="
                            transaction.products[index].item.isPercentage
                              ? percentageOptions
                              : currencyOptions
                          "
                          :isPercentage="
                            transaction.products[index].item.isPercentage ===
                            true
                          "
                        >
                        </CurrencyBaseInput>
                        <button
                          type="button"
                          class="discount-observation-toggle"
                          :class="
                            discountValueIsPositive(
                              transaction.products[index]
                            )
                              ? 'text-primary'
                              : 'text-muted'
                          "
                          :aria-pressed="
                            isDiscountObservationOpen(index) ? 'true' : 'false'
                          "
                          aria-label="Observação para desconto"
                          title="Observação para desconto"
                          @click.stop="toggleDiscountObservation(index)"
                        >
                          <i class="fas fa-clipboard" aria-hidden="true"></i>
                        </button>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col
                v-show="isDiscountObservationOpen(index)"
                cols="12"
                lg="3"
              >
                <b-form-group
                  label="Observação para desconto"
                  label-class="small"
                >
                  <b-form-input
                    v-model="transaction.products[index].item.observation"
                    :disabled="
                      transaction.general.open === false &&
                      transaction.general.id != null
                    "
                    placeholder="Insira a observação para desconto"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- START TYPE PASSEIO -->
            <div
              v-if="
                ['Passeio', 'Experiência','Evento'].includes(
                  transaction.products[index].item.type
                )
              "
            >
              <b-row align-v="center" class="transaction-customer-fields">
                <b-col cols="12" lg="6">
                  <b-form-group label="Nome do cliente" label-class="small">
                    <b-form-input
                      v-model="
                        transaction.products[index].booking.costumer.name
                      "
                      :ref="'bookingNameInput' + index"
                      :class="{ 'is-invalid': isBookingNameInvalid(index) }"
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                      placeholder="Nome"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="6">
                  <b-form-group label="Email" label-class="small">
                    <b-form-input
                      v-model="
                        transaction.products[index].booking.costumer.email
                      "
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                      placeholder="Email"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="6">
                  <b-form-group
                    label="Documento"
                    label-class="small"
                  >
                    <b-form-input
                      v-model="transaction.products[index].booking.costumer.cpf"
                      :class="{
                        'is-invalid':
                          transaction.products[index].booking.costumer.cpf &&
                          !isValidDoc(
                            transaction.products[index].booking.costumer.cpf
                          ),
                      }"
                      maxlength="18"
                      v-mask="
                        getDocMask(
                          transaction.products[index].booking.costumer.cpf
                        )
                      "
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                      placeholder="CPF, CNPJ ou Passaporte do cliente"
                      @keyup="
                        transaction.products[index].booking.costumer.cpf =
                          String(
                            transaction.products[index].booking.costumer.cpf ||
                              ''
                          ).toUpperCase()
                      "
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="6">
                  <b-form-group label="Telefone" label-class="small">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="phone-country-prepend">
                          <button
                            type="button"
                            class="phone-country-flag-button"
                            :ref="'phoneCountryButton' + index"
                            title="Selecionar país"
                            :aria-label="'Selecionar país'"
                            :aria-expanded="
                              phoneCountryOpenIndex === index ? 'true' : 'false'
                            "
                            :disabled="isPhoneCountryDisabled()"
                            @click.stop="togglePhoneCountryList(index)"
                          >
                            <span class="phone-country-flag" aria-hidden="true">{{
                              phoneCountryFlag(index)
                            }}</span>
                          </button>
                          <div
                            v-if="phoneCountryOpenIndex === index"
                            class="phone-country-backdrop"
                            @click="closePhoneCountryList"
                          ></div>
                          <div
                            v-if="phoneCountryOpenIndex === index"
                            class="phone-country-menu"
                            :style="phoneCountryMenuStyle"
                            @click.stop
                          >
                            <input
                              ref="phoneCountrySearch"
                              v-model="phoneCountryQuery"
                              type="text"
                              class="phone-country-search"
                              placeholder="Buscar país"
                              aria-label="Buscar país"
                              @click.stop
                            />
                            <button
                              v-for="(flag, idx) in filteredDialCodes()"
                              :key="flag.iso || idx"
                              type="button"
                              class="phone-country-option"
                              :class="{
                                'is-selected': flag.iso === phoneCountryIso(index),
                              }"
                              @click="selectPhoneCountry(index, flag.iso)"
                            >
                              {{
                                getFlagEmoji(flag.iso) +
                                ' ' +
                                flag.name +
                                ' +' +
                                flag.dialcode
                              }}
                            </button>
                            <div
                              v-if="filteredDialCodes().length === 0"
                              class="phone-country-empty"
                            >
                              Nenhum país encontrado
                            </div>
                          </div>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <div class="phone-number-field">
                        <span class="phone-ddi-prefix">{{
                          phoneDialPrefix(index)
                        }}</span>
                        <b-form-input
                          v-model="
                            transaction.products[index].booking.costumer.phone
                              .number
                          "
                          v-mask="'(##) #####-####'"
                          :style="{ paddingLeft: phoneDialPadding(index) }"
                          :class="{
                            'is-invalid':
                              transaction.products[index].booking.costumer.phone
                                .number &&
                              !isValidPhone(
                                transaction.products[index].booking.costumer
                                  .phone.number
                              ),
                          }"
                          :disabled="
                            transaction.general.open === false &&
                            transaction.general.id != null
                          "
                          placeholder="(00) 00000-0000"
                        ></b-form-input>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row align-v="center">
                <b-col cols="12" lg="7">
                  <b-form-group label="Local" label-class="small">
                    <b-form-select
                      v-model="
                        transaction.products[index].booking.product_place
                      "
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                    >
                      <template #first>
                        <b-form-select-option value="" disabled
                          >Selecione o local</b-form-select-option
                        >
                      </template>

                      <b-form-select-option
                        v-for="(place, place_index) in getAllProductPlaceNames"
                        :value="place"
                        :key="place_index"
                      >
                        {{ place }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" lg="3">
                  <b-form-group label="Data" label-class="small">
                    <date-picker
                      v-model="transaction.products[index].booking.date"
                      :ref="'bookingDatePicker' + index"
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                      type="date"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      class="w-100 transaction-booking-date"
                      :class="{ 'is-invalid': isBookingDateInvalid(index) }"
                      :clearable="false"
                    >
                    </date-picker>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" lg="2">
                  <b-form-group label="Horário" label-class="small">
                    <b-form-select
                      v-if="
                        ['Passeio', 'Experiência','Evento'].includes(product.item.type)
                      "
                      v-model="transaction.products[index].booking.time"
                      :ref="'bookingTimeInput' + index"
                      :class="{ 'is-invalid': isBookingTimeInvalid(index) }"
                    >
                      <template #first>
                        <b-form-select-option value="" disabled
                          >00:00</b-form-select-option
                        >
                      </template>

                      <b-form-select-option
                        v-for="(time, time_index) in getAvaialableTime(index)"
                        :value="time.start"
                        :key="time_index"
                      >
                        {{ time.start }}
                      </b-form-select-option>
                    </b-form-select>
                    <b-form-input
                      v-else
                      v-model="transaction.products[index].booking.time"
                      :ref="'bookingTimeInput' + index"
                      :class="{ 'is-invalid': isBookingTimeInvalid(index) }"
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                      type="time"
                      placeholder="00:00"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="2" v-show="false">
                  <b-form-group label="Qtd. de pessoas" label-class="small">
                    <b-form-input
                      v-model="transaction.products[index].booking.people"
                      :class="{ 'is-invalid': isBookingTicketsInvalid(index) }"
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                      :min="0"
                      type="text"
                      placeholder="Quantidade"
                      @change="checkPeopleAmount(index)"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group
                label="Ingressos"
                label-class="small"
                :class="{ 'is-invalid': isBookingTicketsInvalid(index) }"
              >
                <b-row
                  v-for="(ticket, idx) in expressBookingTickets(index)"
                  :key="ticket.id || idx"
                  class="mb-2 pb-0 transaction-ticket-row"
                  align-v="center"
                >
                  <b-col
                    v-if="!ticket.blocked && ticket.id"
                    cols="12"
                    sm="8"
                    class="ticketselectarea"
                  >
                    <h4 class="mb-0">
                      <i
                        v-if="isTicketBelowMinimum(ticket)"
                        class="fas fa-exclamation-triangle ticket-below-min-icon"
                        :title="
                          'Quantidade abaixo do mínimo (' +
                          Number(ticket.min) +
                          ')'
                        "
                        aria-label="Quantidade abaixo do mínimo"
                      ></i>
                      {{
                        ticket.label +
                        ' (R$' +
                        formatTicketPrice(ticket, index) +
                        ')'
                      }}
                    </h4>

                    <div class="mb-2" style="line-height: 1">
                      <small style="font-size: 70%">
                        {{
                          ticket.label_description &&
                          ticket.label_description.length > 0
                            ? ticket.label_description + ' '
                            : ''
                        }}
                        <br />
                        {{
                          ticket.min &&
                          ticket.min.length > 0 &&
                          ticket.min != '0'
                            ? 'Min: ' + ticket.min
                            : ''
                        }}
                        {{
                          ticket.max &&
                          ticket.max.length > 0 &&
                          ticket.max != '0'
                            ? 'Max: ' + ticket.max
                            : ''
                        }}
                      </small>
                    </div>
                  </b-col>

                  <b-col
                    v-if="!ticket.blocked && ticket.id"
                    cols="12"
                    sm="4"
                    class="transaction-ticket-qty"
                  >
                    <div
                      class="transaction-ticket-qty-controls"
                      :ref="'bookingTicketQty' + index"
                      tabindex="-1"
                    >
                      <b-button
                        @click="decreaseTicketQuantity(ticket, index)"
                        :disabled="disableMinusTicket(ticket)"
                        pill
                        variant="success"
                        size="sm"
                        style="padding: 0.2rem 0.5rem"
                        class="rounded"
                      >
                        <i style="font-size: 10px" class="fas fa-minus"></i>
                      </b-button>
                      <h5 class="mb-0">{{ ticket.quantity || 0 }}</h5>
                      <b-button
                        @click="increaseTicketQuantity(ticket, index)"
                        :disabled="disablePlusTicket(ticket)"
                        pill
                        variant="success"
                        size="sm"
                        style="padding: 0.2rem 0.5rem"
                        class="rounded"
                      >
                        <i style="font-size: 10px" class="fas fa-plus"></i>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <div
                  v-if="isBookingTicketsInvalid(index)"
                  class="invalid-feedback d-block"
                >
                  Selecione ao menos um ingresso
                </div>
              </b-form-group>

              <b-row align-v="center">
                <b-col cols="12">
                  <b-form-group label="" label-class="small">
                    <b-form-textarea
                      v-model="transaction.products[index].booking.observation"
                      :disabled="
                        transaction.general.open === false &&
                        transaction.general.id != null
                      "
                      placeholder="Adicione informações extras"
                    >
                    </b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>

              <hr class="my-2" />
              <b-form-group>
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    v-if="
                      transaction.products[index].booking.term &&
                      transaction.products[index].booking.term.hash
                    "
                  >
                    <label class="font-size-md">Termo de uso</label>
                    <p class="pl-1 mb-0 font-size-md">
                      Número:
                      <span class="text-muted">
                        {{
                          transaction.products[
                            index
                          ].booking.term.hash.substring(0, 6)
                        }}
                      </span>
                    </p>
                    <p class="pl-1 mb-0 font-size-md">
                      Assinatura:
                      <span class="text-muted">
                        {{ getTermSignatureDate(index) }}
                      </span>
                    </p>
                    <p class="pl-1 mb-0 font-size-md">
                      Link do termo:
                      <span class="text-muted">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          @click="copyTermLink(index)"
                        >
                          <i class="fas fa-copy"> </i> copiar
                        </b-button>
                        <b-button
                          size="sm"
                          class="ml-1"
                          variant="outline-primary"
                          @click="openTermLink(index)"
                        >
                          <i class="no no-launch"> </i> abrir
                        </b-button>
                      </span>
                    </p>
                  </b-col>
                  <b-col cols="12" md="6" v-else>
                    <label class="font-size-md">Termo de uso</label>
                    <p class="pl-1 mb-0 font-size-md">
                      Não encontrado
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <label class="font-size-md">Situação da reserva</label>
                    <!-- <p class="pl-1 mb-0 font-size-md">
                      Situação:
                      <span
                        class="font-weight-bold"
                        :style="{
                          color: getBookingHeaderColor(index),
                        }"
                      >
                        {{ getBookingHeaderLabel(index) }}
                      </span>
                    </p> -->
                    <div
                      class="d-flex align-items-center booking-status-switch-row"
                    >
                      <b-form-checkbox
                        switch
                        :checked="isBookingApproved(index)"
                        :disabled="
                          transaction.general.open === false &&
                          transaction.general.id != null
                        "
                        @change="toggleBookingPreReserve(index, $event)"
                        @input="toggleBookingPreReserve(index, $event)"
                        class="booking-pre-reserve-switch"
                      >
                        <span
                          class="font-size-md ml--3"
                          :style="`color: ${getBookingHeaderColor(index)}`"
                        >
                          {{
                            isBookingApproved(index) ? 'Reserva' : 'Pré-reserva'
                          }}
                        </span>
                      </b-form-checkbox>
                    </div>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-row align-h="end">
                <b-col class="text-right">
                  <span
                    >custo do item:
                    <b>
                      {{ formatCurrency(getDiscountedProductPrice(index)) }}</b
                    ></span
                  >
                </b-col>
              </b-row>
            </div>
            <!-- END TYPE PASSEIO -->
          </b-collapse>
        </b-card>
      </div>

      <div>
        <b-row align-h="end">
          <b-col class="text-right">
            <h4>
              Total em produtos:
              <b>{{ formatCurrency(Number(productsTotalDiscountedValue)) }}</b>
            </h4>
          </b-col>
        </b-row>
      </div>
    </div>

    <hr class="mt-5" />

    <div>
      <b-row align-h="start" align-v="center">
        <b-col cols="12" class="pr-0 pb-2">
          <h2 style="color: #12576e; align-items: center; display: flex">
            Pagamentos:
            <small
              @click="addNewPayment()"
              style="
                color: #fff;
                font-size: small;
                padding: 3px 7px !important;
                margin-left: 10px;
                align-items: center;
                display: flex;
              "
              class="btn btn-success p-0 pl-1 pr-1"
              type="button"
              >adicionar</small
            >
            <!-- <small style="color: gray" class="d-block pt-2"
              >Cada entrada de pagamento refletirá como entrada individual no
              relatório financeiro.</small
            > -->
          </h2>
        </b-col>
      </b-row>

      <div
        v-if="
          Object.values(transaction.payments).filter(
            (payment) => !payment.removed
          ).length > 0
        "
        class="pr-2 pl-2 d-none d-lg-block"
        style="margin-bottom: 10px; font-weight: 600; color: #363636"
      >
        <b-row>
          <b-col cols="4">
            <span>Método de pagamento</span>
          </b-col>

          <b-col cols="2">
            <span>Pagador</span>
          </b-col>

          <b-col cols="2">
            <span>Data</span>
          </b-col>

          <b-col cols="2">
            <span>Valor</span>
          </b-col>
        </b-row>
      </div>
      <div
        v-for="(payment, index) in transaction.payments"
        :key="index"
        class="pl-2 pr-2"
      >
        <b-card
          v-if="!payment.removed"
          no-body
          border-variant="light"
          style="margin-top: 0%; margin-bottom: 1%; padding: 1%"
          footer-bg-variant="secondary"
        >
          <b-row align-v="center" class="transaction-payment-summary">
            <b-col cols="12" lg="4">
              <span class="font-weight-normal">
                {{ payment.payment_method.name }}
                <span
                  v-if="hasPaymentLink(payment)"
                  v-html="paymentLinkLabel(payment)"
                ></span>
              </span>
            </b-col>

            <b-col cols="12" lg="2">
              <span class="font-weight-normal">{{
                payment.customer_name
              }}</span>
            </b-col>

            <b-col cols="12" lg="2">
              <span class="font-weight-normal">
                {{
                  payment.date != ''
                    ? formatDate(payment.date, 'DD/MM/YYYY')
                    : ''
                }}
              </span>
            </b-col>

            <b-col cols="12" lg="2">
              <span class="font-weight-normal">
                {{ formatCurrency(Number(payment.value)) }}
              </span>
            </b-col>

            <b-col cols="12" lg="2" class="transaction-summary-actions">

              <i
                v-if="canTogglePaymentCollapse(index)"
                @click="togglePaymentCollapse(index)"
                :class="`no ${
                  isPaymentCollapseOpen(index) ? 'no-up-arrow' : 'no-down-arrow'
                }`"
                style="padding: 4px; margin: 2px"
                type="button"
              ></i>
              <i
                v-if="!isPaymentLinkLocked(payment)"
                @click="removePayment(index)"
                class="no no-trash"
                style="padding: 4px; margin: 2px; color: #d93051"
                type="button"
              >
              </i>
              <i
                v-else
                :class="`${
                  !isApprovedPayment(payment)
                    ? 'no no-trash text-gray'
                    : 'no no-check-bold text-success'
                }`"
                style="padding: 4px; margin: 2px"
              ></i>
            </b-col>
          </b-row>

          <b-collapse
            v-if="!payment.removed"
            :id="'payment_' + index"
            :visible="isPaymentCollapseOpen(index)"
            :accordion="'payment_' + index"
            @shown="onPaymentShow(index)"
            @hidden="onPaymentHide(index)"
            class="pt-1"
          >
            <b-row align-h="start" align-v="center">
              <hr width="90%" />
              <b-col cols="12">
                <b-form-group
                  label="Pago"
                  label-class="small"
                  class="mb-2 payment-done-group"
                >
                  <b-form-checkbox
                    :ref="'paymentDoneCheckbox' + index"
                    switch
                    :checked="transaction.payments[index].date != ''"
                    :disabled="
                      (transaction.payments[index].open == false &&
                        transaction.general.id != null) ||
                      isPaymentLinkLocked(transaction.payments[index])
                    "
                    @change="togglePaymentDone(index, $event)"
                    class="payment-done-switch"
                  >
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-h="start" align-v="center">
              <b-col cols="4">
                <b-form-group
                  label="Método de pagamento"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-select
                    :class="
                      paymentMethodRequired[index] &&
                      !transaction.payments[index].payment_method.index
                        ? 'is-invalid'
                        : ''
                    "
                    v-model="transaction.payments[index].payment_method"
                    :disabled="isPaymentLinkLocked(transaction.payments[index])"
                    @change="
                      resetCardFields(index)
                      resetDateField(index)
                    "
                  >
                    <template #first>
                      <!-- todo como fazer para pagamentos anotados e recorrentes? -->
                      <b-form-select-option
                        :value="{ index: 0, name: 'Pendente' }"
                        disabled
                        >Selecione a método de pagamento</b-form-select-option
                      >
                    </template>

                    <b-form-select-option
                      v-for="(
                        payment_method_index, payment_method_name
                      ) in paymentMethods"
                      :value="{
                        index: payment_method_index,
                        name: payment_method_name,
                      }"
                      sorted
                      :key="payment_method_index"
                    >
                      {{ payment_method_name }}
                    </b-form-select-option>
                  </b-form-select>
                  <div class="invalid-feedback d-block">
                    <span
                      v-if="
                        paymentMethodRequired[index] &&
                        !transaction.payments[index].payment_method.index
                      "
                    >
                      Selecione a método de pagamento
                    </span>
                    <span v-else> &nbsp; </span>
                  </div>
                  <b-button
                    v-if="
                      shouldShowPaymentLinkButton(
                        transaction.payments[index],
                        index
                      )
                    "
                    size="sm"
                    variant="outline-primary"
                    class="mt-1"
                    :disabled="
                      isPaymentLinkButtonDisabled(
                        transaction.payments[index],
                        index
                      )
                    "
                    @click="handlePaymentLinkAction(index)"
                  >
                    {{
                      paymentLinkButtonText(transaction.payments[index], index)
                    }}
                  </b-button>
                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-form-group
                  label="Valor do pagamento"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <CurrencyBaseInput
                    :ref="'paymentValueInput' + index"
                    v-model="transaction.payments[index].value"
                    :modelValue="Number(transaction.payments[index].value)"
                    :isPercentage="false"
                    :options="currencyOptions"
                    :disabled="
                      isPaymentLinkLocked(transaction.payments[index]) ||
                      (transaction.payments[index].open == false &&
                        transaction.general.id != null)
                    "
                    :class="
                      paymentValueRequired[index] &&
                      !(Number(transaction.payments[index].value) > 0)
                        ? 'is-invalid'
                        : ''
                    "
                    @keyup="
                      updateNestedValue('payments', index, '', 'value', $event)
                    "
                    @keydown.native="onPaymentAmountEdited(index, $event)"
                    @paste.native="onPaymentAmountEdited(index, $event)"
                    @blur="onPaymentValueBlur(index, $event)"
                    placeholder="R$ 0,00"
                  >
                  </CurrencyBaseInput>

                  <div class="invalid-feedback d-block">
                    <span
                      v-if="
                        (Number(
                          transaction.payments[index].payment_method.index
                        ) != 0 ||
                          paymentValueRequired[index]) &&
                        !Number(transaction.payments[index].value) > 0 &&
                        transaction.payments[index].removed == false
                      "
                    >
                      Informe um valor maior que zero
                    </span>
                    <span v-else> &nbsp; </span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  :label="
                    Number(transaction.payments[index].payment_method.index) ==
                    9033
                      ? 'Prazo para pagamento'
                      : 'Data do pagamento'
                  "
                  label-class="small"
                >
                  <date-picker
                    v-model="transaction.payments[index].date"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    class="w-100 col-8 pl-0"
                    :clearable="false"
                    required
                    :disabled="
                      transaction.payments[index].date == '' ||
                      isPaymentLinkLocked(transaction.payments[index]) ||
                      (transaction.payments[index].open == false &&
                        transaction.general.id != null)
                    "
                  >
                  </date-picker>
                  <b-form-select
                    v-model="transaction.payments[index].time"
                    v-if="
                      Number(
                        transaction.payments[index].payment_method.index
                      ) == 9033
                    "
                    class="col-4"
                    :ref="'paymentTimeSelect' + index"
                    :disabled="
                      transaction.payments[index].date == '' ||
                      isPaymentLinkLocked(transaction.payments[index]) ||
                      (transaction.payments[index].open == false &&
                        transaction.general.id != null)
                    "
                  >
                    <b-form-select-option
                      v-for="time in paymentTimes"
                      :value="time"
                      :key="time"
                    >
                      {{ time }}
                    </b-form-select-option>
                  </b-form-select>
                  <div class="invalid-feedback d-block">
                    <span
                      v-if="
                        !validatePaymentDate(transaction.payments[index]) &&
                        paymentTypesAllowed.includes(
                          Number(
                            transaction.payments[index].payment_method.index
                          )
                        )
                      "
                    >
                      {{
                        Number(
                          transaction.payments[index].payment_method.index
                        ) == 9033
                          ? 'Informe prazo de pagamento futuro'
                          : 'Informe data de pagamento futura'
                      }}
                    </span>
                    <span v-else> &nbsp; </span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row
              v-if="
                paymentInstallmentsAllowed.includes(
                  Number(transaction.payments[index].payment_method.index)
                )
              "
              align-h="start"
              align-v="center"
            >
              <b-col
                cols="6"
                v-if="
                  paymentTypesAllowed.includes(
                    Number(transaction.payments[index].payment_method.index)
                  ) && transaction.payments[index].payment_types
                "
              >
                <b-form-group label="Formas de pagamento" label-class="small">
                  <b-form-checkbox-group
                    class="payment-type-checks"
                    v-model="transaction.payments[index].payment_types"
                    :options="paymentTypeOptions"
                    stacked
                    @change="onPaymentTypesChange(index, $event)"
                    :disabled="
                      isPaymentLinkLocked(transaction.payments[index]) ||
                      (transaction.payments[index].open == false &&
                        transaction.general.id != null)
                    "
                  >
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="6"
                v-if="
                  paymentCardFlagsAllowed.includes(
                    Number(transaction.payments[index].payment_method.index)
                  )
                "
              >
                <b-form-group
                  label="Bandeira"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-select
                    v-model="transaction.payments[index].card_flag"
                    @onchange="resetInstallments(index)"
                    :class="
                      transaction.payments[index].card_flag != ''
                        ? ''
                        : 'is-invalid'
                    "
                    required
                  >
                    <template #first>
                      <b-form-select-option
                        :value="{ id: null, label: '' }"
                        disabled
                        >Selecione a bandeira do cartão</b-form-select-option
                      >
                    </template>

                    <b-form-select-option
                      v-for="(card_flag, card_flag_index) in cardFlags"
                      :value="{ id: card_flag.id, label: card_flag.label }"
                      :key="card_flag_index"
                    >
                      {{ card_flag.label }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                v-if="
                  paymentInstallmentsAllowed.includes(
                    Number(transaction.payments[index].payment_method.index)
                  )
                "
                cols="6"
              >
                <b-form-group label="Parcelas" label-class="small">
                  <input-number
                    v-model="transaction.payments[index].installments"
                    :min="1"
                    :max="12"
                    :step="1"
                    class="w-100"
                    placeholder="Qntd. de parcelas"
                    :disabled="
                      (transaction.payments[index].open == false &&
                        transaction.general.id != null) ||
                      isPaymentLinkLocked(transaction.payments[index])
                    "
                  >
                  </input-number>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row align-h="start" align-v="center">
              <b-col cols="4">
                <b-form-group
                  label="Nome do pagador"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-input
                    v-model="transaction.payments[index].customer_name"
                    placeholder="Nome do pagador"
                  ></b-form-input>
                  <div class="invalid-feedback d-block">
                    <span
                      v-if="
                        Number(transaction.payments[index].value) > 0 &&
                        transaction.payments[index].customer_name == '' &&
                        Number(
                          transaction.payments[index].payment_method.index
                        ) == 9033
                      "
                    >
                      Informe o nome do pagador
                    </span>
                    <span v-else> &nbsp; </span>
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-form-group
                  label="Documento do pagador"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-input
                    v-model="transaction.payments[index].customer_document"
                    maxlength="18"
                    v-mask="
                      getDocMask(transaction.payments[index].customer_document)
                    "
                    placeholder="CPF, CNPJ ou Passaporte do pagador"
                    @keyup="
                      transaction.payments[index].customer_document = String(
                        transaction.payments[index].customer_document || ''
                      ).toUpperCase()
                    "
                  >
                  </b-form-input>

                  <div class="invalid-feedback d-block">
                    <span
                      v-if="
                        Number(transaction.payments[index].value) > 0 &&
                        transaction.payments[index].customer_document == '' &&
                        Number(
                          transaction.payments[index].payment_method.index
                        ) == 9033
                      "
                    >
                      Informe o nome do pagador
                    </span>
                    <span v-else> &nbsp; </span>
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-form-group
                  label="Nota Fiscal NF"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-input
                    v-model="transaction.payments[index].invoice_number"
                    placeholder="Nota Fiscal"
                  ></b-form-input>
                  <div class="invalid-feedback d-block">
                    <span> &nbsp; </span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row align-h="start" align-v="center">
              <b-col cols="4">
                <b-form-group
                  label="CV"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-input
                    v-model="transaction.payments[index].cv"
                    placeholder="Digite o CV do pagamento"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-form-group
                  label="AUT"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-input
                    v-model="transaction.payments[index].aut"
                    placeholder="Digite o AUT do pagamento"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-form-group
                  label="ID Pix"
                  label-class="small"
                  :disabled="
                    transaction.payments[index].open == false &&
                    transaction.general.id != null
                  "
                >
                  <b-form-input
                    v-model="transaction.payments[index].pix_id"
                    placeholder="Digite o ID Pix do pagamento"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>
      </div>

      <div>
        <b-row align-h="end" class="mt-5 text-right">
          <b-col
            v-if="isDiscountGreaterThanPayments"
            cols="6"
            align-h="start"
            class="text-left"
          >
            <h6 class="text-danger">
              * O valor total de pagamentos não pode ser maior que o valor total
              de produtos.
            </h6>
          </b-col>

          <b-col cols="12" align-h="end">
            <h4>
              Recebido: <b>{{ formatCurrency(Number(paymentsTotalValue)) }}</b>
            </h4>
          </b-col>

          <b-col cols="12" align-h="end">
            <h4 :class="isDiscountGreaterThanPayments ? 'text-danger' : ''">
              A receber:
              <b
                >{{
                  formatCurrency(
                    Number(productsTotalDiscountedValue) -
                      Number(paymentsTotalValue)
                  )
                }}
              </b>
            </h4>
          </b-col>
        </b-row>
      </div>

      <hr class="mt-6" />

      <div>
        <b-row align-h="start" align-v="center">
          <b-col cols="12" class="pr-0">
            <h2 class="transaction-account-info-title">
              Informações da conta:
            </h2>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center">
          <b-col cols="12" sm="6">
            <b-form-group label="Data de abertura" label-class="small">
              <date-picker
                v-model="transaction.general.date"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                class="w-100"
                :disabled="
                  transaction.general.open === false &&
                  transaction.general.id != null
                "
                :clearable="false"
                required
              >
              </date-picker>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center">
          <b-col cols="12" md="6">
            <b-form-group
              label="Colaborador"
              label-class="small"
              :disabled="
                transaction.general.open === false &&
                transaction.general.id != null
              "
            >
              <b-form-input
                v-model="transaction.general.user.name"
                disabled
                placeholder="Nome do colaborador"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="4" md="2">
            <b-form-group
              label="Valor total"
              label-class="small"
              :disabled="
                transaction.general.open === false &&
                transaction.general.id != null
              "
            >
              <CurrencyBaseInput
                v-model="transaction.general.bill_total_value"
                :modelValue="Number(productsTotalValue)"
                disabled
                :options="currencyOptions"
                placeholder="R$ 0,00"
                :isPercentage="false"
              >
              </CurrencyBaseInput>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="4" md="2">
            <b-form-group label="Desconto total" label-class="small">
              <CurrencyBaseInput
                disabled
                v-model="transaction.general.bill_total_discount"
                :modelValue="Number(productsTotalDiscount)"
                :options="currencyOptions"
                placeholder="R$ 0,00"
                :isPercentage="false"
              >
              </CurrencyBaseInput>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="4" md="2">
            <b-form-group
              label="Valor final"
              label-class="small"
              :disabled="
                transaction.general.open === false &&
                transaction.general.id != null
              "
            >
              <CurrencyBaseInput
                disabled
                v-model="transaction.general.bill_final_value"
                :modelValue="Number(productsTotalDiscountedValue)"
                :options="currencyOptions"
                placeholder="R$ 0,00"
                :isPercentage="false"
              >
              </CurrencyBaseInput>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- TODO: criar link via getnet com DATETIME (new field). verify webhook getnet -->
    <import-booking-modal
      v-if="isImportBookingModalOpen"
      :isImportBookingModalOpen="isImportBookingModalOpen"
      @closeImportBookingModal="closeImportBookingModal"
      @importBooking="importBookingFromLead"
    >
    </import-booking-modal>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import moment from 'moment'
import { DatePicker, InputNumber } from 'element-ui'
import { mapActions, mapGetters } from 'vuex'
import { VueMaskDirective } from 'v-mask'
import CurrencyBaseInput from '../../components/Inputs/CurrencyBaseInput.vue'
import nodeService from '../../services/nodejs'
import ImportBookingModal from './ImportBookingModal.vue'

export default {
  name: 'TransactionForm',

  components: {
    DatePicker,
    InputNumber,
    CurrencyBaseInput,
    ImportBookingModal,
  },

  directives: { mask: VueMaskDirective },

  props: {
    currentTransactionID: {
      type: [Number, String],
      default: null,
    },
    changedTransaction: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('financeiro', {
      transaction: 'getInputTransaction',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    ...mapGetters('auth', {
      user: 'user',
      place: 'getPlace',
      roles: 'getRules',
    }),

    ...mapGetters('booking', {
      dialCodesArray: 'getDialCodesArray',
    }),

    paymentMethods() {
      let paymentMethods = {}
      Object.entries(this.user.paymentMethods)
        .sort(function (curr, prev) {
          return prev[0] < curr[0]
        })
        .forEach((pm) => {
          if (pm[0] != 0) {
            paymentMethods[pm[1]] = pm[0]
          }
        })
      return paymentMethods
    },

    poisByType() {
      let poisByType = this.groupBy(this.poisList, (poi) => {
        if (poi.type == 'Passeio') {
          return poi.type
        } else {
          return poi.category[0].name || 'Passeio'
        }
      })

      poisByType.map((poiType) => {
        poiType[1] = poiType[1].sort((curr, prev) => {
          return curr.product_name > prev.product_name
        })
      })

      return poisByType
    },

    getAllProductPlaceNames() {
      //find all product_place_name in poisList and return unique values
      return [
        ...new Set(this.poisList.map((poi) => poi.product_place_name)),
      ].sort()
    },

    productsTotalValue() {
      return this.transaction.products
        .filter((product) => !product.removed)
        .reduce((prev, curr) => Number(curr.item.price) + prev, 0)
    },

    isDiscountGreaterThanPayments() {
      return this.productsTotalDiscountedValue < this.paymentsTotalValue
    },

    disabledSaveButton() {
      return (
        this.isDiscountGreaterThanPayments || !this.transaction.general.open
      )
    },

    automaticTransactionLabel() {
      return this.buildAutomaticTransactionLabel()
    },

    productsTotalDiscount() {
      var totalDiscount = this.transaction.products
        .filter((product) => !product.removed)
        .reduce(function (prev, curr) {
          var discount = Number(curr.item.discount)
          if (curr.item.isPercentage) {
            discount = Number(
              curr.item.price * (curr.item.discount / 100.0)
            ).toFixed(2)
          }

          return discount + prev
        }, 0)

      totalDiscount = Number(totalDiscount).toFixed(2)

      return Number(totalDiscount)
    },

    productsTotalDiscountedValue() {
      var totalValue = this.transaction.products
        .filter((product) => !product.removed)
        .reduce(function (prev, curr) {
          var price = Number(curr.item.price).toFixed(2)
          if (curr.item.isPercentage) {
            price =
              Number(curr.item.price) -
              Number(curr.item.price * (curr.item.discount / 100.0)).toFixed(2)
          } else {
            price = Number(curr.item.price) - Number(curr.item.discount)
          }

          return price + prev
        }, 0)

      totalValue = Number(totalValue).toFixed(2)
      this.transaction.general.bill_total_discount = Number(
        this.productsTotalDiscount
      )
      return Number(totalValue)
    },

    paymentsTotalValue() {
      var totalValue = this.transaction.payments
        .filter((payment) => payment.date != '' && payment.removed == false)
        .reduce((prev, curr) => Number(curr.value) + prev, 0)
      return totalValue
    },
  },

  watch: {
    transaction: {
      deep: true,
      handler() {
        if (!this.transactionChangeReady || !this.transactionBaseline) return

        const hasChanged =
          JSON.stringify(this.transaction) !== this.transactionBaseline
        if (hasChanged === this.transactionHasChanged) return

        this.transactionHasChanged = hasChanged
        this.$emit('emitTransactionHasChanged', hasChanged)
      },
    },

    ['transaction.general.bill_total_value'](newValue, oldValue) {
      this.transaction.general.bill_final_value = new Number(
        this.productsTotalDiscountedValue
      )
      this.transaction.general.bill_total_value = this.productsTotalValue
    },

    ['transaction.general.bill_total_discount'](newValue, oldValue) {
      this.transaction.general.bill_final_value = new Number(
        this.productsTotalDiscountedValue
      )
      this.transaction.general.bill_total_value = this.productsTotalValue
    },

    disabledSaveButton(newValue, oldValue) {
      this.$emit('emitDisabledSaveButton', newValue)
    },

    automaticTransactionLabel(newValue) {
      this.syncTransactionLabel(newValue)
    },

    isDiscountGreaterThanPayments(newValue, oldValue) {
      if (newValue) {
        this.$notify({
          message:
            'O valor total de pagamentos não pode ser maior que o valor total de produtos.',
          duration: 3000,
          type: 'warning',
        })
      }
    },

    productsTotalDiscountedValue() {
      this.syncPendingPaymentAmounts()
    },
  },

  data() {
    return {
      paymentTypesAllowed: [9033], // 9033 - Link getnet
      paymentInstallmentsAllowed: [2, 9033], // 2 - Cartão de crédito, 9033 - Link getnet
      paymentCardFlagsAllowed: [2], // 2 - Cartão de crédito, 9033 - Link getnet
      paymentTypeOptions: [
        { value: 'CREDIT', text: 'Cartão de crédito' },
        { value: 'DEBIT', text: 'Cartão de débito' },
        { value: 'WALLET', text: 'Carteira' },
        { value: 'PIX', text: 'Pix' },
      ],
      transactionHasChanged: false,
      transactionChangeReady: false,
      transactionBaseline: null,
      phoneCountryIsoByIndex: {},
      phoneCountryOpenIndex: null,
      phoneCountryQuery: '',
      phoneCountryMenuStyle: {},
      defaultBookingObject: {
        agents: [],
        auto_checkin: false,
        booking_code: '',
        booking_date: '',
        booking_name: '',
        booking_slug: '',
        channel: '',
        checkins: [],
        cod_booking: false,
        costumer: {
          cpf: '',
          email: '',
          name: '',
          phone: {
            area_code: '55',
            number: '',
          },
        },
        created_date: '',
        description: '',
        free_booking: false,
        // product_place: '',
        observation: '',
        date: '',
        time: '',
        people: '',
        hash: '',
        status: '',
        items: [
          {
            id: '',
            title: '',
            label: '',
            quantity: 0,
            unit_price: 0,
            unit_discount: 0,
            booking_name: '',
            booking_slug: '',
          },
        ],
        order: {},
        payLater: false,
        product: {
          address: '',
          id: '',
          name: '',
          place: '',
          place_uuid: '',
          product_nps: '',
          uuid: '',
        },
        payments: [
          {
            payment_value: '',
            payment_method: '',
            payment_status: '',
            payment_description: '',
            payment_date: '',
            transaction_id: '',
          },
        ],
        term: {
          hash: '',
          confirm: true,
          datetime: '',
        },
      },
      defaultProductObject: {
        item: {
          product: {},
          uuid: '',
          product_name: '',
          type: '',
          price: 0,
          discount: 0,
          final_price: 0,
          isPercentage: false,
          discountType: 'none',
          observation: '',
          category: '',
          subcategory: '',
        },
        booking: {},
        readonly: false,
        removed: false,
      },
      isImportBookingModalOpen: false,
      defaultPaymentObject: {
        payment_method: { index: 0, name: 'Pendente' },
        value: 0,
        date: '',
        time: '',
        cv: '',
        aut: '',
        pix_id: '',
        invoice_number: '',
        customer_name: '',
        customer_document: '',
        card_flag: { id: null, label: '' },
        installments: 1,
        payment_link: {},
        payment_types: ['CREDIT'],
        max_installments: 2,
        readonly: false,
        removed: false,
        open: true,
      },
      activeProductIndex: -1,
      activePaymentIndex: -1,
      localStored_transaction: null,
      daysOfWeek: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ],
      paymentTimes: [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
      ],
      percentageOptions: {
        locale: 'pt-BR',
        currency: 'BRL',
        currencyDisplay: 'hidden',
        precision: 2,
        hideCurrencySymbolOnFocus: true,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        useGrouping: false,
        accountingSign: false,
        valueRange: { min: 0, max: 100 },
      },
      currencyOptions: {
        locale: 'pt-BR',
        currency: 'BRL',
        currencyDisplay: 'symbol',
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        useGrouping: true,
        accountingSign: false,
      },
      discountsType: [
        { value: 'none', label: 'Sem desconto' },
        { value: 'percent', label: '%' },
        { value: 'amount', label: 'R$' },
      ],
      discountObservationOpen: {},
      paymentValueRequired: {},
      paymentMethodRequired: {},
      generatingPaymentLinks: {},
      generatedPaymentLinks: {},
      cardFlags: [
        { id: 1, label: 'American Express (Amex)' },
        { id: 2, label: 'Diners Club International' },
        { id: 3, label: 'Discover' },
        { id: 4, label: 'Elo' },
        { id: 5, label: 'Hipercard' },
        { id: 6, label: 'JCB (Japan Credit Bureau)' },
        { id: 7, label: 'Maestro' },
        { id: 8, label: 'Mastercard' },
        { id: 9, label: 'UnionPay (China Union Pay)' },
        { id: 10, label: 'Visa' },
        { id: 11, label: 'Visa Electron' },
      ],
    }
  },

  methods: {
    ensureProductBooking(product, index) {
      if (product.item.product.type !== 'Passeio') {
        return
      }
      if (!product.booking) {
        product.booking = JSON.parse(
          JSON.stringify(this.defaultBookingObject)
        )
      }
      if (!product.booking.items) {
        const currentItemPrice = product.item.price
        this.updateTransactionBooking(index, true)
        if (product.item.price !== '') {
          product.item.price = currentItemPrice
        }
      }
    },
    openTermLink(index) {
      if (!this.transaction.products[index].booking.term) {
        this.$notify({
          message: 'Não há termo de compromisso para esta reserva.',
          duration: 3000,
          type: 'warning',
        })
        return
      }
      const termLink = `/booking-details/${this.transaction.products[index].booking.booking_code}/${this.transaction.products[index].booking.term.hash}`
      if (termLink) {
        window.open(termLink, '_blank')
      }
    },
    getTermSignatureDate(index) {
      if (!this.transaction.products[index].booking.term) {
        return ''
      }
      return moment(
        this.transaction.products[index].booking.term.datetime
      ).format('DD/MM/YYYY HH:mm')
    },
    copyTermLink(index) {
      if (!this.transaction.products[index].booking.term) {
        return
      }
      const termLink = this.transaction.products[index].booking.term.hash
      if (termLink) {
        navigator.clipboard.writeText(termLink)
      }
    },

    getProductBooking(index) {
      return (
        (this.transaction.products[index] &&
          this.transaction.products[index].booking) ||
        null
      )
    },

    isProductBookingPaid(booking, index) {
      if (!booking) return false
      const payments = booking.payments || []
      const totalPaid = payments.reduce((acc, payment) => {
        if (String(payment.payment_status || '').toUpperCase() === 'APPROVED') {
          return acc + Number(payment.payment_value || 0)
        }
        return acc
      }, 0)
      let finalValue =
        booking.finalValue != null
          ? booking.finalValue
          : booking.valor != null
          ? booking.valor
          : booking.order && booking.order.final_value != null
          ? booking.order.final_value
          : null
      if (
        (finalValue == null || finalValue === '') &&
        index != null &&
        typeof this.getDiscountedProductPrice === 'function'
      ) {
        finalValue = this.getDiscountedProductPrice(index)
      }
      return totalPaid >= Number(finalValue || 0)
    },

    hasProductBookingCheckin(booking) {
      if (!booking) return false
      if (booking.checkin && booking.checkin.hasCheckin) return true
      if (booking.checkins && booking.checkins.length > 0) return true
      if (
        booking.checkin &&
        booking.checkin.list &&
        booking.checkin.list.length > 0
      ) {
        return true
      }
      return false
    },

    getBookingHeaderLabel(index) {
      const booking = this.getProductBooking(index)
      if (!booking) return ''
      const status = String(booking.status || '').toUpperCase()
      const isPaid = this.isProductBookingPaid(booking, index)
      if (status === 'CANCELLED') return 'cancelada'
      if (status === 'APPROVED' && !isPaid) return 'pré-reserva'
      if (!isPaid) return 'cotação'
      if (this.hasProductBookingCheckin(booking)) return 'utilizado'
      return 'Aguardando check-in'
    },

    getBookingHeaderColor(index) {
      const booking = this.getProductBooking(index)
      const status = String(booking.status || '').toUpperCase()
      const isPaid = this.isProductBookingPaid(booking, index)
      if (status === 'CANCELLED') return '#D93051'
      if (
        status === 'APPROVED' &&
        booking.payments[0].payment_status !== 'APPROVED'
      )
        return '#e67e22'
      if (!isPaid) return '#999'
      if (this.hasProductBookingCheckin(booking)) return 'rgb(32, 155, 103)'
      return '#1A6884'
    },

    isBookingApproved(index) {
      const booking = this.getProductBooking(index)
      if (!booking || !booking.payments || !booking.payments[0]) return false
      return (
        String(booking.status || '').toUpperCase() === 'APPROVED' &&
        String(booking.payments[0].payment_status || '').toUpperCase() ===
          'APPROVED'
      )
    },

    ensureBookingPayment(index) {
      const booking = this.getProductBooking(index)
      if (!booking) return null
      if (!booking.payments) {
        this.$set(booking, 'payments', [])
      }
      if (!booking.payments[0]) {
        this.$set(booking.payments, 0, {
          payment_value: '',
          payment_method: '',
          payment_status: 'PENDING',
          payment_description: '',
          payment_date: '',
          transaction_id: '',
        })
      }
      return booking.payments[0]
    },

    normalizeSwitchChecked(checked, currentlyOn) {
      if (typeof checked === 'boolean') return checked
      if (checked === 'true' || checked === 1 || checked === '1') return true
      if (checked === 'false' || checked === 0 || checked === '0') return false
      if (checked && typeof checked === 'object' && checked.target) {
        return !!checked.target.checked
      }
      return !currentlyOn
    },

    toggleBookingPreReserve(index, checked) {
      const booking = this.getProductBooking(index)
      const payment = this.ensureBookingPayment(index)
      if (!booking || !payment) return

      const currentlyOn = this.isBookingApproved(index)
      const isOn = this.normalizeSwitchChecked(checked, currentlyOn)
      if (isOn === currentlyOn) return

      this.$set(booking, 'status', 'APPROVED')
      this.$set(payment, 'payment_status', isOn ? 'APPROVED' : 'PENDING')
      this.$set(payment, 'payment_description', isOn ? 'Pago' : 'Pendente')
    },

    ...mapActions('product', ['fetchPOIs']),
    ...mapActions('booking', ['fetchDialCodes']),

    customerNameForLabel(name) {
      const parts = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
      if (!parts.length) return ''
      if (parts.length === 1) return parts[0]
      if (parts.length === 2) return `${parts[1]} ${parts[0]}`
      return parts[0]
    },

    uniqueJoined(values) {
      const seen = {}
      return values.filter((value) => {
        const key = String(value).toLowerCase()
        if (!value || seen[key]) return false
        seen[key] = true
        return true
      }).join(' | ')
    },

    isBookingProductType(type) {
      return ['Passeio', 'Experiência', 'Evento'].indexOf(type) >= 0
    },

    isBookingProduct(product) {
      if (!product || product.removed) return false
      return this.isBookingProductType(product.item && product.item.type)
    },

    productDiscountType(product) {
      const item = (product && product.item) || {}
      if (
        item.discountType === 'none' ||
        item.discountType === 'percent' ||
        item.discountType === 'amount'
      ) {
        return item.discountType
      }
      if (item.isPercentage === true || item.isPercentage === 'true') {
        return 'percent'
      }
      const discount = Number(item.discount)
      if (!isNaN(discount) && discount > 0) return 'amount'
      return 'none'
    },

    discountTypeLabel(product) {
      const type = this.productDiscountType(product)
      if (type === 'percent') return '%'
      if (type === 'amount') return 'R$'
      return 'Tipo'
    },

    isDiscountObservationOpen(index) {
      return !!this.discountObservationOpen[index]
    },

    toggleDiscountObservation(index) {
      this.$set(
        this.discountObservationOpen,
        index,
        !this.discountObservationOpen[index]
      )
    },

    discountValueIsPositive(product) {
      const discount = Number(product && product.item && product.item.discount)
      return !isNaN(discount) && discount > 0
    },

    shiftDiscountObservationOpen(removedIndex) {
      const next = {}
      Object.keys(this.discountObservationOpen).forEach((key) => {
        const current = Number(key)
        if (Number.isNaN(current) || current === removedIndex) return
        const target = current > removedIndex ? current - 1 : current
        next[target] = this.discountObservationOpen[key]
      })
      this.discountObservationOpen = next
    },

    onProductDiscountTypeChange(index, type) {
      const item = this.transaction.products[index].item
      const next = type === 'percent' || type === 'amount' ? type : 'none'
      this.$set(item, 'discountType', next)
      item.isPercentage = next === 'percent'
      if (next === 'none') {
        item.discount = 0
      }
      this.updateProductsDiscount(index)
    },

    onDiscountValueBlur(index) {
      const product = this.transaction.products[index]
      if (!product || !product.item) return
      if (this.productDiscountType(product) === 'none') {
        if (Number(product.item.discount) !== 0) {
          product.item.discount = 0
          this.updateProductsDiscount(index)
        }
        return
      }

      this.$nextTick(() => {
        const ref = this.$refs['discountInput' + index]
        const component = Array.isArray(ref) ? ref[0] : ref
        let raw = component ? component.numberValue : product.item.discount
        if (raw && typeof raw === 'object' && 'value' in raw) {
          raw = raw.value
        }
        const invalid =
          raw == null ||
          raw === '' ||
          (typeof raw === 'number'
            ? Number.isNaN(raw)
            : Number.isNaN(Number(raw)))
        if (!invalid) return
        this.$set(product.item, 'discount', 0)
        if (component && typeof component.setValue === 'function') {
          component.setValue(0)
        }
        this.updateProductsDiscount(index)
      })
    },

    bookingCustomerName(product) {
      const customer = product.booking && product.booking.costumer
      return String((customer && customer.name) || '').trim()
    },

    isBookingNameInvalid(index) {
      const product = this.transaction.products[index]
      if (!this.isBookingProduct(product)) return false
      return !this.bookingCustomerName(product)
    },

    isBookingDateInvalid(index) {
      const product = this.transaction.products[index]
      if (!this.isBookingProduct(product)) return false
      return !(product.booking && product.booking.date)
    },

    isBookingTimeInvalid(index) {
      const product = this.transaction.products[index]
      if (!this.isBookingProduct(product)) return false
      const time = product.booking && product.booking.time
      return !String(time || '').trim()
    },

    bookingTicketQuantity(product) {
      const items = (product.booking && product.booking.items) || []
      return items.reduce((sum, item) => {
        if (!item || item.blocked || !item.id) return sum
        return sum + (Number(item.quantity) || 0)
      }, 0)
    },

    isBookingTicketsInvalid(index) {
      const product = this.transaction.products[index]
      if (!this.isBookingProduct(product)) return false
      const quantity = this.bookingTicketQuantity(product)
      const people = Number(product.booking && product.booking.people) || 0
      return !(quantity > 0) || !(people > 0)
    },

    ensureBookingPeopleFromTickets(index) {
      const product = this.transaction.products[index]
      if (!product || !product.booking) return
      const quantity = this.bookingTicketQuantity(product)
      if (quantity > 0 && !(Number(product.booking.people) > 0)) {
        product.booking.people = quantity
      }
    },

    validateBookingProducts() {
      let valid = true
      let firstInvalid = -1
      ;(this.transaction.products || []).forEach((product, index) => {
        if (!this.isBookingProduct(product)) return
        this.ensureBookingPeopleFromTickets(index)
        const missing = []
        if (this.isBookingNameInvalid(index)) missing.push('nome do cliente')
        if (this.isBookingDateInvalid(index)) missing.push('data')
        if (this.isBookingTimeInvalid(index)) missing.push('horário')
        if (this.isBookingTicketsInvalid(index)) {
          missing.push('ao menos um ingresso')
        }
        if (!missing.length) return
        valid = false
        if (firstInvalid < 0) firstInvalid = index
        this.$notify({
          message: `Preencha ${missing.join(', ')}. Produto: ${index + 1} ${firstInvalid}`,
          duration: 6000,
          type: 'error',
        })
      })
      if (firstInvalid >= 0) {
        this.activeProductIndex = firstInvalid
        console.log('activeProductIndex', this.activeProductIndex, index)
        this.$nextTick(() => {
          this.$root.$emit('bv::show::collapse', 'product_' + (index+1))
          this.$nextTick(() => {
            this.focusPendingBookingField(firstInvalid)
          })
        })
      }
      return valid
    },

    focusPendingBookingField(index) {
      let refName = null
      if (this.isBookingNameInvalid(index)) {
        refName = 'bookingNameInput' + index
      } else if (this.isBookingDateInvalid(index)) {
        refName = 'bookingDatePicker' + index
      } else if (this.isBookingTimeInvalid(index)) {
        refName = 'bookingTimeInput' + index
      } else if (this.isBookingTicketsInvalid(index)) {
        refName = 'bookingTicketQty' + index
      }
      if (!refName) return
      this.focusBookingControl(this.bookingFieldRef(refName))
    },

    bookingFieldRef(name) {
      const ref = this.$refs[name]
      if (!ref) return null
      return Array.isArray(ref) ? ref[0] : ref
    },

    focusBookingControl(component) {
      if (!component) return
      const root = component.$el || component
      if (!root) return
      const focusableSelector =
        'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
      let target = null
      if (root.matches && root.matches(focusableSelector)) {
        target = root
      } else if (typeof root.querySelector === 'function') {
        target = root.querySelector(focusableSelector)
      }
      if (!target) target = root
      if (typeof target.focus === 'function') {
        target.focus()
      }
      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ block: 'center' })
      }
    },

    payerFromFirstBookingProduct() {
      const product = (this.transaction.products || []).find((item) => {
        if (!item || item.removed) return false
        return this.isBookingProductType(item.item && item.item.type)
      })
      const customer =
        (product && product.booking && product.booking.costumer) || {}
      return {
        name: customer.name || '',
        document: customer.cpf || '',
      }
    },

    activeTransactionProducts() {
      return (this.transaction.products || []).filter(
        (product) => product && !product.removed
      )
    },

    buildAutomaticTransactionLabel() {
      const products = this.activeTransactionProducts()
      const bookingProducts = products.filter((product) =>
        this.isBookingProductType(product.item && product.item.type)
      )

      if (bookingProducts.length > 0) {
        const names = bookingProducts.map((product) =>
          this.customerNameForLabel(
            product.booking &&
              product.booking.costumer &&
              product.booking.costumer.name
          )
        )
        const label = this.uniqueJoined(names)
        if (label) return label
      }

      const categories = products.map((product) => {
        const category = product.item && product.item.category
        if (Array.isArray(category)) {
          const first = category[0]
          return (first && (first.name || first)) || ''
        }
        return category || ''
      })
      return this.uniqueJoined(categories)
    },

    syncTransactionLabel(nextLabel) {
      const label =
        nextLabel != null ? nextLabel : this.buildAutomaticTransactionLabel()
      if (!this.transaction.general) return
      if (this.transaction.general.label === label) return
      this.$set(this.transaction.general, 'label', label)
    },

    syncTransactionBaseline() {
      this.transactionBaseline = JSON.stringify(this.transaction)
      sessionStorage.setItem('stored_transaction', this.transactionBaseline)
      if (this.transactionHasChanged) {
        this.transactionHasChanged = false
        this.$emit('emitTransactionHasChanged', false)
      }
    },

    async settleTransactionBaseline() {
      this.transactionChangeReady = false
      this.syncTransactionBaseline()
      await this.$nextTick()
      this.syncTransactionBaseline()
      await this.$nextTick()
      this.syncTransactionBaseline()
      this.transactionChangeReady = true
    },

    normalizeDoc(doc) {
      return String(doc || '').replace(/\D/g, '')
    },

    isValidCnpj(doc) {
      if (doc.length !== 14) return false
      if (/^(\d)\1+$/.test(doc)) return false

      const calcDigit = (base, weights) => {
        let sum = 0
        for (let i = 0; i < weights.length; i++) {
          sum += Number(base[i]) * weights[i]
        }
        const rest = sum % 11
        return rest < 2 ? 0 : 11 - rest
      }

      const digit1 = calcDigit(doc, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
      if (digit1 !== Number(doc[12])) return false

      const digit2 = calcDigit(doc, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
      return digit2 === Number(doc[13])
    },

    isValidPassport(doc) {
      const passport = String(doc || '')
        .trim()
        .toUpperCase()
      if (passport.length !== 8) return false
      return /^[A-Z]{2}[0-9]{6}$/.test(passport)
    },

    isValidDoc(doc) {
      const raw = String(doc || '')
        .trim()
        .toUpperCase()
      if (!raw) return false
      if (this.isValidPassport(raw)) return true

      const normalized = this.normalizeDoc(raw)
      if (normalized.length == 14) {
        return this.isValidCnpj(normalized)
      }
      if (normalized.length !== 11) {
        return false
      }
      if (/^(\d)\1+$/.test(normalized)) {
        return false
      }

      let sum = 0
      for (let i = 0; i < 9; i++) sum += Number(normalized[i]) * (10 - i)
      let rest = (sum * 10) % 11
      if (rest === 10) rest = 0
      if (rest !== Number(normalized[9])) return false

      sum = 0
      for (let i = 0; i < 10; i++) sum += Number(normalized[i]) * (11 - i)
      rest = (sum * 10) % 11
      if (rest === 10) rest = 0
      return rest === Number(normalized[10])
    },

    getDocMask(value) {
      const doc = String(value || '')
      if (/[A-Za-z]/.test(doc)) {
        return 'AA######'
      }

      const digits = this.normalizeDoc(doc)
      if (digits.length > 11) {
        return '##.###.###/####-##'
      }
      return '###.###.###-##'
    },

    isValidPhone(phone) {
      return this.normalizeDoc(phone).length >= 10
    },

    getFlagEmoji(countryCode) {
      if (!countryCode) return ''
      const codePoints = String(countryCode)
        .toUpperCase()
        .split('')
        .map((char) => 127397 + char.charCodeAt())
      return String.fromCodePoint(...codePoints)
    },

    ensureCustomerPhone(product) {
      if (!product || !product.booking || !product.booking.costumer) return
      if (!product.booking.costumer.phone) {
        this.$set(product.booking.costumer, 'phone', {
          area_code: '55',
          number: '',
        })
        return
      }
      if (!product.booking.costumer.phone.area_code) {
        this.$set(product.booking.costumer.phone, 'area_code', '55')
      }
      if (product.booking.costumer.phone.number == null) {
        this.$set(product.booking.costumer.phone, 'number', '')
      }
    },

    onPhoneAreaCodeChange(index, areaCode) {
      const phone =
        this.transaction.products[index] &&
        this.transaction.products[index].booking &&
        this.transaction.products[index].booking.costumer &&
        this.transaction.products[index].booking.costumer.phone

      if (!phone) {
        this.ensureCustomerPhone(this.transaction.products[index])
      }

      this.$set(
        this.transaction.products[index].booking.costumer.phone,
        'area_code',
        String(areaCode || '55')
      )
    },

    phoneCountryIso(index) {
      const phone =
        this.transaction.products[index] &&
        this.transaction.products[index].booking &&
        this.transaction.products[index].booking.costumer &&
        this.transaction.products[index].booking.costumer.phone
      const areaCode = String((phone && phone.area_code) || '55')
      const list = this.dialCodesArray || []
      const remembered = this.phoneCountryIsoByIndex[index]
      if (remembered) {
        const selected = list.find((country) => country.iso === remembered)
        if (selected && String(selected.dialcode) === areaCode) {
          return remembered
        }
      }
      const match = list.find(
        (country) => String(country.dialcode) === areaCode
      )
      return match ? match.iso : 'BR'
    },

    phoneCountryFlag(index) {
      return this.getFlagEmoji(this.phoneCountryIso(index)) || '🇧🇷'
    },

    phoneDialPrefix(index) {
      const phone =
        this.transaction.products[index] &&
        this.transaction.products[index].booking &&
        this.transaction.products[index].booking.costumer &&
        this.transaction.products[index].booking.costumer.phone
      return '+' + String((phone && phone.area_code) || '55')
    },

    phoneDialPadding(index) {
      const prefix = this.phoneDialPrefix(index)
      return `calc(0.75rem + ${prefix.length}ch + 0.35rem)`
    },

    isPhoneCountryDisabled() {
      return (
        this.transaction.general &&
        this.transaction.general.open === false &&
        this.transaction.general.id != null
      )
    },

    filteredDialCodes() {
      const query = String(this.phoneCountryQuery || '')
        .trim()
        .toLowerCase()
      const list = this.dialCodesArray || []
      if (!query) return list
      return list.filter((country) => {
        const name = String(country.name || '').toLowerCase()
        const dial = String(country.dialcode || '')
        const iso = String(country.iso || '').toLowerCase()
        return (
          name.indexOf(query) !== -1 ||
          dial.indexOf(query) !== -1 ||
          iso.indexOf(query) !== -1
        )
      })
    },

    togglePhoneCountryList(index) {
      if (this.isPhoneCountryDisabled()) return
      if (this.phoneCountryOpenIndex === index) {
        this.closePhoneCountryList()
        return
      }
      this.phoneCountryQuery = ''
      this.phoneCountryOpenIndex = index
      this.$nextTick(() => {
        const ref = this.$refs['phoneCountryButton' + index]
        const button = Array.isArray(ref) ? ref[0] : ref
        if (button && button.getBoundingClientRect) {
          const rect = button.getBoundingClientRect()
          this.phoneCountryMenuStyle = {
            top: rect.bottom + 4 + 'px',
            left: rect.left + 'px',
          }
        }
        const search = this.$refs.phoneCountrySearch
        const input = Array.isArray(search) ? search[0] : search
        if (input && input.focus) input.focus()
      })
    },

    closePhoneCountryList() {
      this.phoneCountryOpenIndex = null
      this.phoneCountryQuery = ''
    },

    selectPhoneCountry(index, iso) {
      this.onPhoneCountryChange(index, iso)
      this.closePhoneCountryList()
    },

    onPhoneCountryChange(index, iso) {
      const country = (this.dialCodesArray || []).find(
        (item) => item.iso === iso
      )
      this.$set(
        this.phoneCountryIsoByIndex,
        index,
        country ? country.iso : 'BR'
      )
      this.onPhoneAreaCodeChange(index, country ? country.dialcode : '55')
    },

    validatePaymentDate(payment) {
      let time = payment.time || '00:00'
      return (
        payment.date != '' &&
        moment().isBefore(moment(`${payment.date} ${time}`), 'minute')
      )
    },

    paymentLinkLabel(payment) {
      let labelStatusClass = ''
      if (payment.payment_link) {
        if (payment.open) {
          if (
            moment().isBefore(
              moment(`${payment.date} ${payment.time}`),
              'minute'
            )
          ) {
            labelStatusClass = 'font-weight-bold text-muted text-primary'
          } else {
            labelStatusClass = 'font-weight-bold text-muted text-warning'
          }
        } else {
          labelStatusClass = 'font-weight-bold text-muted text-success'
        }
      } else if (payment.payment_method.index == 9033) {
        labelStatusClass = 'font-weight-bold text-muted'
      }
      return `<sub class="${labelStatusClass}">${this.paymentLinkStatus(
        payment
      )}</sub>`
    },

    formatCurrency(value) {
      const numero = Number(value)
      return numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },

    isApprovedPayment(payment) {
      return payment && payment.open == false && payment.date != ''
    },

    hasPaymentLink(payment) {
      return Boolean(
        payment && payment.payment_link && payment.payment_link.link
      )
    },

    paymentLinkStatus(payment) {
      if (this.hasPaymentLink(payment)) {
        if (this.isApprovedPayment(payment)) {
          return 'pago online'
        }
        return 'aguardando pagamento'
      }
      return 'sem link'
    },

    isPaymentLinkExpired(payment, index) {
      if (!this.hasPaymentLink(payment) || this.generatedPaymentLinks[index]) {
        return false
      }

      const expireDate = moment(payment.payment_link.expire_date)
      return !expireDate.isValid() || !expireDate.isAfter(moment())
    },

    isPaymentLinkLocked(payment) {
      return this.isApprovedPayment(payment) || this.hasPaymentLink(payment)
    },

    shouldShowPaymentLinkButton(payment, index) {
      return (
        (Number(payment.payment_method.index) == 9033 &&
          Number(payment.value) > 0) ||
        (this.hasPaymentLink(payment) &&
          !this.isPaymentLinkExpired(payment, index) &&
          !this.isApprovedPayment(payment))
      )
    },

    isPaymentLinkButtonDisabled(payment, index) {
      return (
        !payment.payment_types ||
        payment.payment_types.length == 0 ||
        payment.customer_name == '' ||
        payment.customer_document == '' ||
        (!this.validatePaymentDate(payment) && !payment.payment_link.link) ||
        this.isApprovedPayment(payment) ||
        this.isPaymentLinkExpired(payment, index) ||
        Boolean(this.generatingPaymentLinks[index])
      )
    },

    onPaymentTypesChange(index, value) {
      const paymentTypes = Array.isArray(value) ? [...value] : []
      this.$set(this.transaction.payments[index], 'payment_types', paymentTypes)
    },

    paymentLinkButtonText(payment, index) {
      if (this.isPaymentLinkExpired(payment, index)) return 'link expirado'
      if (this.hasPaymentLink(payment)) {
        if (this.isApprovedPayment(payment)) {
          const paymentDate = moment(payment.date)
          const formattedDate = paymentDate.isValid()
            ? paymentDate.format('DD/MM/YYYY, HH[h]mm')
            : payment.date
          return `pago online em ${formattedDate}`
        }
        return 'Copiar link'
      }
      if (this.generatingPaymentLinks[index]) return 'Gerando link...'

      if (payment.value == 0) return ''
      return 'Gerar link'
    },

    async handlePaymentLinkAction(index) {
      const payment = this.transaction.payments[index]
      if (
        this.transaction.general.id == null ||
        (this.transactionHasChanged && !this.hasPaymentLink(payment))
      ) {
        swal
          .fire({
            text: 'A conta será salva antes de continuar',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Salvar e Continuar',
            confirmButtonClass: 'btn btn-primary',
            cancelButtonText: 'Voltar',
            cancelButtonClass: 'btn btn-secondary',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              console.log('emitSaveTransaction', {
                id: this.transaction.general.id,
                reopenTransactionID: payment.id ? payment.id : 'last',
              })
              this.$emit('emitSaveTransaction', {
                id: this.transaction.general.id,
                reopenTransactionID: payment.id ? payment.id : 'last',
              })
            }
          })
        return
      }
      if (
        this.isApprovedPayment(payment) ||
        this.isPaymentLinkExpired(payment, index)
      ) {
        return
      }

      if (this.hasPaymentLink(payment)) {
        await this.copyPaymentLink(payment.payment_link.link)
        return
      }

      await this.generateGetnetPaymentLink(index)
      return this.transaction.payments[index].payment_link
    },

    maskCustomerDocument(customerDocument) {
      const digits = String(customerDocument || '').replace(/\D/g, '')

      if (!digits) return ''

      if (digits.length <= 11) {
        const cpf = digits.padStart(11, '0').slice(-11)
        return `${cpf.substring(0, 3)}.***.***-${cpf.substring(9, 11)}`
      }

      const cnpj = digits.padStart(14, '0').slice(-14)
      return `${cnpj.substring(0, 2)}.***.***/${cnpj.substring(
        8,
        12
      )}-${cnpj.substring(12, 14)}`
    },

    buildPaymentLinkDescription(id, customerName, customerDocument) {
      const maskedDocument = this.maskCustomerDocument(customerDocument)
      const prefix = `C${id} - `
      const suffix = maskedDocument ? ` - ${maskedDocument}` : ''
      const maxNameLength = Math.max(0, 35 - prefix.length - suffix.length)
      const name = String(customerName || '')
        .trim()
        .substring(0, maxNameLength)

      return `${prefix}${name}${suffix}`.substring(0, 35)
    },

    async generateGetnetPaymentLink(index) {
      const payment = this.transaction.payments[index]
      const general = this.transaction.general
      this.$set(this.generatingPaymentLinks, index, true)
      try {
        const payload = {
          value: Number(payment.value),
          expire_date: String(
            moment(`${payment.date} ${payment.time}`).format('YYYY-MM-DD HH:mm')
          ),
          tx_id: Number(general.id),
          payment_index: Number(index),
          description: this.buildPaymentLinkDescription(
            general.id,
            payment.customer_name,
            payment.customer_document
          ),
          cpf: payment.customer_document,
          customer_name: payment.customer_name,
          customer_email: payment.customer_email || 'teste@janoo.com.br',
          payment_types: Array.isArray(payment.payment_types)
            ? payment.payment_types
            : ['CREDIT'],
          max_installments: payment.installments
            ? Number(payment.installments)
            : this.defaultPaymentObject.max_installments,
        }
        const response = await nodeService.createGetnetPaymentLink(payload)
        const result = response.data || response
        const paymentLink = result.payment_link || {}

        if (!paymentLink.link) {
          throw new Error('A Getnet não retornou o link de pagamento.')
        }

        this.$set(payment, 'payment_link', paymentLink)
        this.$set(this.generatedPaymentLinks, index, true)
        this.$notify({
          message: 'Link de pagamento gerado com sucesso.',
          duration: 3000,
          type: 'success',
        })
      } catch (error) {
        this.$notify({
          message:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            'Não foi possível gerar o link de pagamento.',
          duration: 3000,
          type: 'error',
        })
      } finally {
        this.$set(this.generatingPaymentLinks, index, false)
      }
    },

    async copyPaymentLink(link) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(link)
        } else {
          const input = document.createElement('textarea')
          input.value = link
          input.setAttribute('readonly', '')
          input.style.position = 'absolute'
          input.style.left = '-9999px'
          document.body.appendChild(input)
          input.select()
          const copied = document.execCommand('copy')
          document.body.removeChild(input)
          if (!copied) throw new Error('Falha ao copiar o link.')
        }

        this.$notify({
          message: 'Link de pagamento copiado com sucesso.',
          duration: 3000,
          type: 'success',
        })
      } catch (error) {
        this.$notify({
          message: 'Não foi possível copiar o link de pagamento.',
          duration: 3000,
          type: 'error',
        })
      }
    },

    togglePaymentDone(index, done) {
      const paymentValue = Number(this.transaction.payments[index].value)
      if (done) {
        if (!(paymentValue > 0)) {
          this.transaction.payments[index].date = moment().format('YYYY-MM-DD')
          this.$set(this.paymentValueRequired, index, true)
          this.$set(this.paymentMethodRequired, index, true)
          this.$nextTick(() => {
            const input = this.$refs['paymentValueInput' + index]
            const component = Array.isArray(input) ? input[0] : input
            if (component && typeof component.focus === 'function') {
              component.focus()
            }
          })
          return
        }
        this.transaction.payments[index].date = moment().format('YYYY-MM-DD')
        return
      }

      this.$set(this.paymentValueRequired, index, false)
      this.$set(this.paymentMethodRequired, index, false)
      this.transaction.payments[index].date = ''
      this.transaction.payments[index].time = ''
      this.transaction.payments[index].value = 0
      this.transaction.payments[index].payment_method.index = 0
      this.transaction.payments[index].payment_method.name = 'Pendente'
    },

    onPaymentValueBlur(index, value) {
      const paymentValue = Number(
        value !== undefined && value !== null
          ? value
          : this.transaction.payments[index].value
      )

      if (paymentValue > 0) {
        this.$set(this.paymentValueRequired, index, false)
        return
      }

      if (this.$refs['paymentDoneCheckbox' + index]) {
        const input = this.$refs['paymentDoneCheckbox' + index]
        const component = Array.isArray(input) ? input[0] : input
        if (component.checked == true) {
          this.$set(this.paymentValueRequired, index, true)
        } else {
          this.$set(this.paymentValueRequired, index, false)
        }
      }
    },

    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)

        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return Array.from(map)
    },

    formatDate(date, format) {
      return moment(date).format(format)
    },

    getDiscountedProductPrice(index) {
      var product = this.transaction.products[index]

      if (product.item.isPercentage) {
        var percentageDiscount = Number(product.item.discount) / 100
        return (
          Number(product.item.price) -
          Number(product.item.price * percentageDiscount)
        )
      } else {
        return Number(product.item.price) - Number(product.item.discount)
      }
    },

    getAvaialableTime(index) {
      var vm = this
      const product = this.transaction.products[index]
      var times = []

      if (product.booking.date.length > 0) {
        var booking_date = moment(product.booking.date)

        const poiIndex = this.poisList.findIndex(
          (p) => p.uuid == vm.transaction.products[index].item.uuid
        )
        if (poiIndex >= 0) {
          Object.entries(this.poisList[poiIndex].availability).map(function (
            value,
            index
          ) {
            if (
              moment(value[0]).isValid() &&
              moment(value[0]).isSame(booking_date)
            ) {
              times = value[1].map(function (val, idx) {
                return val
              })
            } else {
              const weekdayName = value[0].toLowerCase()
              const weekdayIndex = vm.daysOfWeek.indexOf(weekdayName)

              if (weekdayIndex == booking_date.weekday()) {
                times = value[1].map(function (val, idx) {
                  return val
                })
              }
            }
          })
        }
      }

      return times
    },

    isPaymentCollapseOpen(index) {
      return index === this.activePaymentIndex
    },

    isProductCollapseOpen(index) {
      const onlyOneProduct =
        this.transaction.general.id == null &&
        Object.values(this.transaction.products).filter(
          (product) => !product.removed
        ).length == 1

      return index === this.activeProductIndex
    },

    onPaymentShow(index) {
      this.activePaymentIndex = index
    },

    onPaymentHide(index) {
      if (this.activePaymentIndex === index) this.activePaymentIndex = -1
    },

    onProductShow(index) {
      this.activeProductIndex = index
    },

    onProductHide(index) {
      if (this.activeProductIndex === index) this.activeProductIndex = -1
    },

    toggleProductCollapse(index) {
      console.log('toggleProductCollapse', index)
      this.activeProductIndex = index
      this.$root.$emit('bv::toggle::collapse', 'product_' + index)
      this.transaction.products[index].readonly = false
    },

    togglePaymentCollapse(index) {
      this.activePaymentIndex = index
      this.$root.$emit('bv::toggle::collapse', 'payment_' + index)
      this.transaction.payments[index].readonly = false
    },

    isNewProduct() {
      const validProducts = this.transaction.products.filter(
        (product) => product.removed == false
      )
      return validProducts.length == 1 && validProducts[0].item.uuid == ''
    },

    addNewProduct() {
      let lastIndex = 0
      if (!this.isNewProduct()) {
        this.transaction.products.push(
          JSON.parse(JSON.stringify(this.defaultProductObject))
        )
        lastIndex = this.transaction.products.length - 1
      }
      this.toggleProductCollapse(lastIndex)
    },

    openImportBookingModal() {
      this.isImportBookingModalOpen = true
    },

    closeImportBookingModal() {
      this.isImportBookingModalOpen = false
    },

    importBookingFromLead(lead) {
      const isImported = this.transaction.products.find((product) => {
        return (
          product.booking.booking_code === lead.booking_code &&
          product.removed === false
        )
      })
      if (isImported) {
        this.$notify({
          message: `A reserva #${lead.booking_code} já foi importada para esta conta`,
          duration: 3000,
          type: 'warning',
        })
        return
      }
      const product = JSON.parse(JSON.stringify(this.defaultProductObject))
      product.booking = JSON.parse(JSON.stringify(lead))
      product.booking.status = 'APPROVED'

      const poiIndex = this.poisList.findIndex(
        (p) => p.uuid === lead.product.uuid
      )
      if (poiIndex >= 0) {
        const poi = this.poisList[poiIndex]
        product.item.uuid = poi.uuid
        product.item.type = poi.type
        product.item.product_name = poi.product_name
        product.item.category =
          poi.category != undefined && poi.category.length > 0
            ? poi.category[0].name
            : ''
        product.item.subcategory =
          poi.subcategory != undefined && poi.subcategory.length > 0
            ? poi.subcategory[0].name
            : ''
      }

      let totalDiscount = (lead.items || []).reduce((total, item) => {
        const unitDiscount = Number(item.unit_discount)
        return total + unitDiscount * Number(item.quantity)
      }, 0)
      product.item.price = (lead.items || []).reduce((total, item) => {
        const unitPrice = Number(item.unit_price)
        return total + Number(item.quantity) * unitPrice
      }, 0)

      product.item.discount = 0
      product.item.isPercentage = false
      product.item.final_price = Number(product.item.price) - Number(totalDiscount)
      let payment = product.booking.payments[0] || {}
      payment = {
        ...payment,
        ...{
          // payment_value: product.item.price,
          // payment_method: 'cod',
          // payment_status: this.transaction.payments[0].date == null ? 'PENDING' : 'APPROVED',
          // payment_description: this.transaction.payments[0].date == null ? 'Pendente' : 'Pago',
          // payment_date: this.transaction.payments[0].date == null ? '' : this.transaction.payments[0].date,
          transaction_id: this.transaction.general.id || null,
        },
      }
      product.item.discount = totalDiscount
      product.item.isPercentage = false
      product.booking.payments[0] = payment
      this.transaction.products.push(JSON.parse(JSON.stringify(product)))
      const lastIndex = this.transaction.products.length - 1
      this.ensureCustomerPhone(this.transaction.products[lastIndex])
      this.transaction.products[lastIndex].booking.items = this.updateTickets(
        poiIndex,
        lastIndex,
        lead.items
      )
      this.toggleProductCollapse(lastIndex)
      this.updateProductsValue(lastIndex)
      if (
        this.transaction.products.length == 2 &&
        this.transaction.products[0].item.uuid == ''
      ) {
        this.removeProduct(0)
      }
    },
    isNewPayment() {
      const validPayments = this.transaction.payments.filter(
        (payment) => payment.removed == false
      )
      if (validPayments.length != 1) return false
      const payment = validPayments[0]
      if (Number(payment.payment_method && payment.payment_method.index) != 0) {
        return false
      }
      if (Number(payment.value) == 0) return true
      if (this.paymentAmountTouched && this.paymentAmountTouched.has(payment)) {
        return false
      }
      if (this.committedPayments && this.committedPayments.has(payment)) {
        return false
      }
      return true
    },
    pendingPaymentAmount(excludeIndex) {
      const total = Number(this.productsTotalDiscountedValue) || 0
      const entered = (this.transaction.payments || []).reduce(
        (sum, payment, index) => {
          if (index === excludeIndex || !payment || payment.removed) return sum
          return sum + (Number(payment.value) || 0)
        },
        0
      )
      const pending = this.roundMoney(total - entered)
      return pending > 0 ? pending : 0
    },
    assignPaymentAmount(payment, amount) {
      if (!payment) return
      const next = this.roundMoney(Math.max(0, Number(amount) || 0))
      if (this.roundMoney(Number(payment.value) || 0) === next) return
      this.suppressPaymentAmountTouch = (this.suppressPaymentAmountTouch || 0) + 1
      payment.value = next
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.suppressPaymentAmountTouch -= 1
        })
      })
    },
    trackPaymentForPendingSync(payment) {
      if (!payment) return
      this.pendingSyncPayments = [payment]
    },
    onPaymentAmountEdited(index, event) {
      if (this.suppressPaymentAmountTouch) return
      if (event && event.type === 'keydown') {
        const key = event.key
        const isEdit =
          key === 'Backspace' ||
          key === 'Delete' ||
          (key >= '0' && key <= '9')
        if (!isEdit) return
      }
      const payment = this.transaction.payments[index]
      if (!payment || !this.paymentAmountTouched) return
      this.paymentAmountTouched.set(payment, true)
      this.pendingSyncPayments = (this.pendingSyncPayments || []).filter(
        (item) => item !== payment
      )
    },
    applyPendingPaymentAmount(index) {
      const payment = this.transaction.payments[index]
      if (!payment || payment.removed) return
      if (this.paymentAmountTouched && this.paymentAmountTouched.has(payment)) {
        return
      }
      this.assignPaymentAmount(payment, this.pendingPaymentAmount(index))
      this.trackPaymentForPendingSync(payment)
    },
    syncDefaultPlaceholderPayment() {
      if (!this.transaction.general || this.transaction.general.id != null) return
      const active = []
      ;(this.transaction.payments || []).forEach((payment, index) => {
        if (payment && !payment.removed) active.push({ payment, index })
      })
      if (active.length !== 1) return
      const payment = active[0].payment
      const index = active[0].index
      if (this.paymentAmountTouched && this.paymentAmountTouched.has(payment)) {
        return
      }
      if (this.committedPayments && this.committedPayments.has(payment)) return
      if (Number(payment.payment_method && payment.payment_method.index) != 0) {
        return
      }
      const total = Number(this.productsTotalDiscountedValue) || 0
      const tracked = (this.pendingSyncPayments || []).indexOf(payment) >= 0
      if (!(total > 0) && Number(payment.value) == 0) return
      if (Number(payment.value) > 0 && !tracked) return
      this.assignPaymentAmount(payment, this.pendingPaymentAmount(index))
      this.trackPaymentForPendingSync(payment)
    },
    syncPendingPaymentAmounts() {
      const payments = this.transaction.payments || []
      ;(this.pendingSyncPayments || []).forEach((payment) => {
        const index = payments.indexOf(payment)
        if (index < 0 || !payment || payment.removed) return
        if (this.paymentAmountTouched && this.paymentAmountTouched.has(payment)) {
          return
        }
        this.assignPaymentAmount(payment, this.pendingPaymentAmount(index))
      })
      this.syncDefaultPlaceholderPayment()
    },
    releaseUncommittedPendingAmounts() {
      ;(this.transaction.payments || []).forEach((payment) => {
        if (!payment || payment.removed) return
        if (this.committedPayments && this.committedPayments.has(payment)) return
        if (this.paymentAmountTouched && this.paymentAmountTouched.has(payment)) {
          return
        }
        if (Number(payment.payment_method && payment.payment_method.index) != 0) {
          return
        }
        if (payment.date) return
        if (!(Number(payment.value) > 0)) return
        payment.value = 0
      })
    },
    addNewPayment() {
      const payer = this.payerFromFirstBookingProduct()
      let lastIndex = 0
      if (!this.isNewPayment()) {
        const payment = JSON.parse(JSON.stringify(this.defaultPaymentObject))
        payment.customer_name = payer.name
        payment.customer_document = payer.document
        this.transaction.payments.push(payment)
        lastIndex = this.transaction.payments.length - 1
      } else {
        const payment = this.transaction.payments[lastIndex]
        if (
          payment &&
          !payment.customer_name &&
          !payment.customer_document
        ) {
          this.$set(payment, 'customer_name', payer.name)
          this.$set(payment, 'customer_document', payer.document)
        }
      }

      const addedPayment = this.transaction.payments[lastIndex]
      if (this.committedPayments && addedPayment) {
        this.committedPayments.add(addedPayment)
      }
      this.applyPendingPaymentAmount(lastIndex)

      this.togglePaymentCollapse(lastIndex)
      this.$nextTick(() => {
        const input = this.$refs['paymentValueInput' + lastIndex]
        const component = Array.isArray(input) ? input[0] : input
        if (component && typeof component.focus === 'function') {
          component.focus()
        }
      })
    },

    isEmptyPlaceholderProduct(product) {
      if (!product || product.removed) return true
      const hasUuid = product.item && product.item.uuid
      const hasBooking = product.booking && product.booking.booking_code
      return !hasUuid && !hasBooking
    },

    canTogglePaymentCollapse(index) {
      return index != 0 || this.transaction.payments[0].value > 0 || this.transaction.payments[0].payment_method.index != 0
    },
    canRemoveProduct(index) {
      const product = this.transaction.products[index]
      if (!product || product.removed) return false
      if (
        this.transaction.general.open === false &&
        this.transaction.general.id != null
      ) {
        return false
      }
      const activeProducts = this.transaction.products.filter(
        (item) => !item.removed
      )
      if (
        activeProducts.length === 1 &&
        this.isEmptyPlaceholderProduct(product)
      ) {
        return false
      }
      return true
    },

    ensurePlaceholderProduct() {
      const hasVisibleProduct = this.transaction.products.some(
        (product) => !product.removed
      )
      if (hasVisibleProduct) return

      const placeholder = JSON.parse(JSON.stringify(this.defaultProductObject))
      if (!placeholder.booking || !placeholder.booking.costumer) {
        placeholder.booking = JSON.parse(
          JSON.stringify(this.defaultBookingObject)
        )
      }
      this.transaction.products.push(placeholder)
      this.toggleProductCollapse(this.transaction.products.length - 1)
    },

    bookingIdentityKeys(product) {
      const booking = product && product.booking
      if (!booking) return []
      return [booking.hash, booking.booking_code].filter(Boolean)
    },

    // Reservas que já estavam nesta conta e o operador tirou nesta edição.
    bookingsLeavingAccount() {
      if (!this.transactionBaseline || !this.transaction.general.id) return []

      let baseline
      try {
        baseline = JSON.parse(this.transactionBaseline)
      } catch (error) {
        return []
      }

      const persisted = {}
      ;(baseline.products || []).forEach((product) => {
        if (!product || product.removed) return
        this.bookingIdentityKeys(product).forEach((key) => {
          persisted[key] = true
        })
      })

      return (this.transaction.products || []).filter((product) => {
        if (!product || !product.removed) return false
        return this.bookingIdentityKeys(product).some((key) => persisted[key])
      })
    },

    parseBookingRecord(response) {
      const data = response && response.data
      const record = Array.isArray(data) ? data[0] : data
      if (!record) return null
      let payload = record.payload || {}
      if (typeof payload === 'string') {
        try {
          payload = JSON.parse(payload)
        } catch (error) {
          payload = {}
        }
      }
      return {
        hash: record.hash || payload.hash || '',
        payload,
      }
    },

    activeBookingVehicles(payload) {
      const stored = payload && (payload.vehicles || payload.vehicle)
      const list = Array.isArray(stored) ? stored : stored ? [stored] : []
      return list.filter(
        (item) =>
          item &&
          item.active !== false &&
          (item.uuid || item.resource_uuid || item.name)
      )
    },

    activeBookingConductors(payload) {
      const agents = payload && payload.agents
      const list = Array.isArray(agents) ? agents : []
      const seen = {}
      return list.filter((agent) => {
        if (!agent || !agent.uuid || agent.active === false) return false
        if (seen[agent.uuid]) return false
        seen[agent.uuid] = true
        return true
      })
    },

    notifyBookingReleaseError(code, action, error) {
      const apiMessage =
        (error && error.data && error.data.message) ||
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.message) ||
        ''
      this.$notify({
        message: apiMessage
          ? `Não foi possível ${action} da reserva #${code}: ${apiMessage}`
          : `Não foi possível ${action} da reserva #${code}. A conta não foi salva.`,
        duration: 8000,
        type: 'danger',
      })
    },

    // A conta só perde a reserva depois que veículos e condutores saíram dela.
    async releaseBookingsLeavingAccount() {
      const products = this.bookingsLeavingAccount()
      for (let index = 0; index < products.length; index++) {
        const released = await this.releaseBookingAssignments(products[index])
        if (!released) return false
      }
      return true
    },

    async releaseBookingAssignments(product) {
      const booking = (product && product.booking) || {}
      const lookup = booking.hash || booking.booking_code
      const code = booking.booking_code || lookup
      if (!lookup) return true

      let details
      try {
        details = this.parseBookingRecord(
          await nodeService.getBookingByUUID(lookup)
        )
      } catch (error) {
        this.notifyBookingReleaseError(code, 'consultar', error)
        return false
      }
      if (!details) {
        this.notifyBookingReleaseError(code, 'consultar')
        return false
      }

      const hash = details.hash || booking.hash || lookup
      const vehicles = this.activeBookingVehicles(details.payload)
      for (let index = 0; index < vehicles.length; index++) {
        const uuid = vehicles[index].uuid || vehicles[index].resource_uuid
        if (!uuid) {
          this.notifyBookingReleaseError(code, 'remover os veículos')
          return false
        }
        try {
          await nodeService.postRemoveBookingVehicle({ hash, uuid })
        } catch (error) {
          this.notifyBookingReleaseError(code, 'remover os veículos', error)
          return false
        }
      }
      if (vehicles.length) {
        try {
          details = this.parseBookingRecord(
            await nodeService.getBookingByUUID(lookup)
          )
        } catch (error) {
          this.notifyBookingReleaseError(code, 'consultar', error)
          return false
        }
        if (!details) {
          this.notifyBookingReleaseError(code, 'consultar')
          return false
        }
      }

      const conductors = this.activeBookingConductors(
        details.payload || {}
      ).filter((agent) => agent.source !== 'vehicle')
      for (let index = 0; index < conductors.length; index++) {
        try {
          await nodeService.postRemoveBookingAgent({
            hash,
            uuid: conductors[index].uuid,
          })
        } catch (error) {
          this.notifyBookingReleaseError(code, 'remover o condutor', error)
          return false
        }
      }

      return true
    },

    removeProduct(index) {
      if (!this.canRemoveProduct(index)) {
        return
      }

      if (this.transaction.general.id == null) {
        this.transaction.products.splice(index, 1)
        this.shiftDiscountObservationOpen(index)
      } else {
        this.transaction.products[index].removed = true
      }

      this.ensurePlaceholderProduct()

      setTimeout(() => {
        const nextIndex = this.transaction.products.findIndex(
          (product) => !product.removed
        )
        if (nextIndex >= 0) {
          this.updateProductsValue(nextIndex)
        }
      }, 2000)
    },

    removePayment(index) {
      if (this.transaction.general.id == null) {
        if (this.transaction.payments.length > 1) {
          this.transaction.payments.splice(index, 1)
          return
        }
      } else {
        if (this.transaction.payments.length > 1) {
          this.transaction.payments[index].removed = true
          return
        }
      }
      this.transaction.payments[index].value = 0
      this.transaction.payments[index].payment_method.index = 0
      this.transaction.payments[index].payment_method.name = 'Pendente'
      this.togglePaymentCollapse(index)
    },

    retractPayment(index) {
      this.transaction.payments[index].readonly = true
      this.$root.$emit('bv::toggle::collapse', 'payment_' + index)
    },

    // retractProduct(index) {
    //   this.transaction.products[index].readonly = true
    //   if (this.activeProductIndex === index) this.activeProductIndex = -1
    // },

    resetCardFields(index) {
      if (
        !this.paymentInstallmentsAllowed.includes(
          Number(this.transaction.payments[index].payment_method.index)
        )
      ) {
        this.transaction.payments[index].card_flag = { id: null, label: '' }
        this.transaction.payments[index].installments = 1
      }
    },

    resetDateField(index) {
      if (Number(this.transaction.payments[index].payment_method.index) != 0) {
        this.transaction.payments[index].date = moment().format('YYYY-MM-DD')
      }

      if (
        Number(this.transaction.payments[index].payment_method.index) == 9033
      ) {
        this.$set(this.transaction.payments[index], 'payment_types', [
          'CREDIT',
          'PIX',
        ])
        this.transaction.payments[index].time = moment()
          .add(1, 'hour')
          .format('HH:00')

        this.$nextTick(() => {
          const input = this.$refs['paymentTimeSelect' + index]
          const component = Array.isArray(input) ? input[0] : input
          if (component && typeof component.focus === 'function') {
            //component.focus()
          }
        })
      } else {
        this.transaction.payments[index].time = ''
      }
    },

    resetInstallments(index) {
      this.transaction.payments[index].installments = 1
    },

    rememberProductPois() {
      ;(this.transaction.products || []).forEach((product) => {
        this.rememberProductPoi(product)
      })
    },

    rememberProductPoi(product) {
      if (!product) return
      if (!this.productPoiUuids) this.productPoiUuids = new WeakMap()
      const uuid = (product.item && product.item.uuid) || ''
      this.productPoiUuids.set(product, uuid)
    },

    previousProductUuid(product) {
      if (!this.productPoiUuids) this.productPoiUuids = new WeakMap()
      if (this.productPoiUuids.has(product)) {
        return this.productPoiUuids.get(product) || ''
      }
      const nextUuid = (product.item && product.item.uuid) || ''
      const slug = product.booking && product.booking.booking_slug
      if (slug) {
        const bySlug = (this.poisList || []).find((poi) => {
          const entry =
            poi.special_prices &&
            poi.special_prices[0] &&
            poi.special_prices[0][0]
          return entry && entry.slug == slug && poi.uuid != nextUuid
        })
        if (bySlug) return bySlug.uuid
      }
      const name = product.item && product.item.product_name
      const type = product.item && product.item.type
      if (!name) return ''
      const byName = (this.poisList || []).find(
        (poi) =>
          poi.product_name == name &&
          (!type || poi.type == type) &&
          poi.uuid != nextUuid
      )
      return (byName && byName.uuid) || ''
    },

    zeroPoiTicketQuantities(uuid) {
      if (!uuid) return
      const poi = (this.poisList || []).find((item) => item.uuid == uuid)
      if (!poi || !poi.tickets) return
      Object.values(poi.tickets).forEach((ticket) => {
        if (!ticket || typeof ticket !== 'object') return
        if (ticket.quantity === undefined) {
          this.$set(ticket, 'quantity', 0)
        } else {
          ticket.quantity = 0
        }
      })
    },

    zeroBookingItemQuantities(product) {
      const items = product.booking && product.booking.items
      if (!Array.isArray(items)) return
      items.forEach((item) => {
        if (!item) return
        if (item.quantity === undefined) {
          this.$set(item, 'quantity', 0)
        } else {
          item.quantity = 0
        }
      })
    },

    clearChangedProductTickets(product, previousUuid, nextUuid) {
      this.zeroPoiTicketQuantities(previousUuid)
      this.zeroPoiTicketQuantities(nextUuid)
      this.zeroBookingItemQuantities(product)
      if (product.booking) {
        product.booking.people = ''
      }
    },

    updateTransactionBooking(productIndex, changed = false, productChange = false) {
      const vm = this
      const product = this.transaction.products[productIndex]
      let previousUuid = ''
      let nextUuid = ''
      if (changed && productChange && product) {
        previousUuid = this.previousProductUuid(product)
        nextUuid = (product.item && product.item.uuid) || ''
        this.clearChangedProductTickets(product, previousUuid, nextUuid)
      }
      const poiIndex = this.poisList.findIndex(
        (p) => p.uuid == vm.transaction.products[productIndex].item.uuid
      )

      if (poiIndex >= 0 && changed) {
        this.transaction.products[productIndex].item.uuid =
          this.poisList[poiIndex].uuid
        this.transaction.products[productIndex].item.type =
          this.poisList[poiIndex].type
        if (
          !productChange &&
          !this.isBookingProductType(
            this.transaction.products[productIndex].item.type
          ) &&
          this.transaction.products[productIndex].item.price == 0
        ) {
          this.transaction.products[productIndex].item.price =
            this.poisList[poiIndex].price
        }
        this.transaction.products[productIndex].item.product_name =
          this.poisList[poiIndex].product_name
        this.transaction.products[productIndex].item.category =
          this.poisList[poiIndex].category != undefined &&
          this.poisList[poiIndex].category.length > 0
            ? this.poisList[poiIndex].category[0].name
            : ''
        this.transaction.products[productIndex].item.subcategory =
          this.poisList[poiIndex].subcategory != undefined &&
          this.poisList[poiIndex].subcategory.length > 0
            ? this.poisList[poiIndex].subcategory[0].name
            : ''

        if (
          ['Passeio', 'Experiência','Evento'].indexOf(
            this.transaction.products[productIndex].item.type
          ) >= 0
        ) {
          let booking = JSON.parse(
            JSON.stringify(this.transaction.products[productIndex].booking)
          )
          booking = {
            ...JSON.parse(JSON.stringify(this.defaultBookingObject)),
            ...booking,
          }

          // booking.product_place = this.getAllProductPlaceNames[poiPlaceIndex]
          booking.booking_name =
            this.poisList[poiIndex]['special_prices'][0][0]['name']
          booking.booking_slug =
            this.poisList[poiIndex]['special_prices'][0][0]['slug']
          booking.description =
            this.poisList[poiIndex].product_name + ' - Registro Interno'

          booking.items = this.updateTickets(
            poiIndex,
            productIndex,
            booking.items
          )
          this.transaction.products[productIndex].booking = booking
        }
        if (productChange) {
          this.clearChangedProductTickets(product, previousUuid, nextUuid)
          this.transaction.products[productIndex].item.price = ''
        }
        this.updateProductsValue(productIndex)
        this.rememberProductPoi(this.transaction.products[productIndex])
      } else if (productChange && product) {
        this.clearChangedProductTickets(product, previousUuid, nextUuid)
        product.item.price = ''
        this.updateProductsValue(productIndex)
        this.rememberProductPoi(product)
      }
    },
    bookingSpecialPrice(poi, slug) {
      const list = poi && poi.special_prices && poi.special_prices[0]
      if (!Array.isArray(list) || !list.length) return null
      if (slug) {
        const match = list.find((entry) => entry && entry.slug == slug)
        if (match) return match
      }
      return list[0]
    },

    catalogTicket(poi, ticket) {
      if (!poi || !poi.tickets || !ticket) return null
      return (
        poi.tickets[ticket.id] ||
        Object.values(poi.tickets).find((item) => item && item.id == ticket.id) ||
        null
      )
    },

    expressBookingTickets(index) {
      const product = this.transaction.products[index]
      const items = (product && product.booking && product.booking.items) || []
      const poi = (this.poisList || []).find(
        (item) => item.uuid == (product && product.item && product.item.uuid)
      )
      const special = this.bookingSpecialPrice(
        poi,
        product && product.booking && product.booking.booking_slug
      )
      if (!special || !Array.isArray(special.tickets)) return items
      const allowed = special.tickets.map((id) => String(id))
      return items.filter(
        (ticket) => ticket && allowed.includes(String(ticket.id))
      )
    },

    formatTicketPrice(ticket, index) {
      return this.resolveTicketUnitPrice(ticket, index)
        .toFixed(2)
        .replace('.', ',')
    },

    updateTickets(poiIndex, productIndex, items) {
      const poi = this.poisList[poiIndex]
      if (!poi || !poi.tickets) return []
      const product = this.transaction.products[productIndex]
      const slug = product.booking && product.booking.booking_slug
      const special = this.bookingSpecialPrice(poi, slug)
      const allowed =
        special && Array.isArray(special.tickets)
          ? special.tickets.map((id) => String(id))
          : null
      const source = items || []
      const hasTicketLines = source.some(
        (item) => item && item.id && Number(item.quantity) > 0
      )
      const tickets = []

      Object.entries(poi.tickets).forEach(([key, poiTicket]) => {
        if (!poiTicket || !poiTicket.id) return
        if (
          allowed &&
          !allowed.includes(String(key)) &&
          !allowed.includes(String(poiTicket.id))
        ) {
          return
        }

        const ticket = JSON.parse(JSON.stringify(poiTicket))
        delete ticket.identity_required
        ticket.booking_name = special
          ? special.name
          : (product.booking && product.booking.booking_name) || ''
        ticket.booking_slug = special ? special.slug : slug || ''
        ticket.picture_url = (poi.images && poi.images[0]) || ''
        ticket.title = ticket.label + ' - ' + poi.product_name
        ticket.unit_discount = 0
        if (ticket.max == 'default' && special) ticket.max = special.max_persons
        if (ticket.min == 'default') ticket.min = 0

        // Mesma regra da reserva expressa: só "default" herda o preço do tipo.
        // Zero é preço de cortesia e permanece zero.
        let price = this.ticketCatalogUnitPrice(ticket.price, special)
        const existing = source.find((item) => item && item.id == ticket.id)
        if (existing) {
          const saved = Number(
            existing.unit_price != null && existing.unit_price !== ''
              ? existing.unit_price
              : existing.price
          )
          if (saved > 0) price = saved
          if (existing.quantity != null) ticket.quantity = existing.quantity
        } else if (hasTicketLines) {
          ticket.quantity = 0
        }
        // Conta antiga, sem linhas de ingresso: o total de pessoas ficava no ingresso padrão.
        // Com ingressos na reserva, cada linha vale só a própria quantidade.
        if (
          !hasTicketLines &&
          ticket.id == '000001' &&
          (ticket.quantity == null || ticket.quantity === '')
        ) {
          ticket.quantity = Number(product.booking && product.booking.people) || 0
        }
        ticket.price = price
        ticket.unit_price = price
        tickets.push(ticket)
      })

      return tickets
    },
    updateNestedValue(array, index, group, field, value) {
      if (index >= 0) {
        if (group.length > 0) {
          this.transaction[array][index][group] = value
        } else if (field.length > 0) {
          this.transaction[array][index][group][field] = value
        }
      } else {
        if (group.length > 0) {
          this.transaction[array][group] = value
        } else if (field.length > 0) {
          this.transaction[array][group][field] = value
        }
      }
    },

    updateProductsValue(index) {
      this.transaction.general.bill_total_value = this.productsTotalValue
      this.transaction.products[index].item.final_price =
        Number(this.getDiscountedProductPrice(index))
      this.transaction.general.bill_final_value = new Number(
        this.productsTotalDiscountedValue
      )
    },

    updateProductsDiscount(index) {
      this.transaction.general.bill_total_discount = Number(
        this.productsTotalDiscount
      )
      this.transaction.products[index].item.final_price =
        Number(this.getDiscountedProductPrice(index))
      this.transaction.general.bill_final_value = new Number(
        this.productsTotalDiscountedValue
      )
    },

    checkPeopleAmount(index) {
      this.transaction.products[index].booking.people =
        this.transaction.products[index].booking.people.replace(/\D+/g, '')
    },

    roundMoney(value) {
      return Math.round((Number(value) || 0) * 100) / 100
    },

    ticketCatalogUnitPrice(catalogPrice, special) {
      if (catalogPrice == 'default') {
        const number = Number(special && special.price)
        return isNaN(number) ? 0 : number
      }
      const number = Number(catalogPrice)
      return isNaN(number) ? 0 : number
    },

    resolveTicketUnitPrice(ticket, index) {
      const product = this.transaction.products[index]
      const poi = (this.poisList || []).find(
        (item) => item.uuid == (product && product.item && product.item.uuid)
      )
      const special = this.bookingSpecialPrice(
        poi,
        product && product.booking && product.booking.booking_slug
      )
      const catalog = this.catalogTicket(poi, ticket)
      const catalogPrice = catalog && catalog.price
      if (catalogPrice == 'default' || (ticket && ticket.price) == 'default') {
        return this.ticketCatalogUnitPrice('default', special)
      }

      const numeric = (value) => {
        if (value == null || value === '' || value === 'default') return null
        const number = Number(value)
        return isNaN(number) ? null : number
      }

      const unit = numeric(ticket && ticket.unit_price)
      if (unit != null) return unit
      const price = numeric(ticket && ticket.price)
      if (price != null) return price
      const fromCatalog = numeric(catalogPrice)
      if (fromCatalog != null) return fromCatalog
      return 0
    },

    ticketsTotal(items, index) {
      const total = (items || []).reduce((sum, item) => {
        if (!item || !item.id) return sum
        const quantity = Number(item.quantity) || 0
        if (quantity <= 0) return sum
        return sum + quantity * this.resolveTicketUnitPrice(item, index)
      }, 0)
      return this.roundMoney(total)
    },

    ticketQuantitiesKey(items) {
      return (items || [])
        .filter((item) => item && item.id)
        .map((item) => `${item.id}:${Number(item.quantity) || 0}`)
        .join('|')
    },

    snapshotTicketState(ticket, index) {
      const product = this.transaction.products[index]
      const poi = this.poisList.find((item) => item.uuid == product.item.uuid)
      const catalog = poi && poi.tickets ? poi.tickets[ticket.id] : null
      return {
        items: JSON.parse(JSON.stringify(product.booking.items || [])),
        people: product.booking.people,
        catalogRef: catalog,
        catalog: catalog
          ? {
              quantity: catalog.quantity,
              price: catalog.price,
              unit_price: catalog.unit_price,
            }
          : null,
      }
    },

    restoreTicketState(index, snapshot) {
      const product = this.transaction.products[index]
      product.booking.items = snapshot.items
      product.booking.people = snapshot.people
      if (snapshot.catalogRef && snapshot.catalog) {
        snapshot.catalogRef.quantity = snapshot.catalog.quantity
        snapshot.catalogRef.price = snapshot.catalog.price
        snapshot.catalogRef.unit_price = snapshot.catalog.unit_price
      }
    },

    async confirmTicketPriceRecalculation(index, snapshot) {
      const product = this.transaction.products[index]
      const currentItems = product.booking.items || []
      if (
        this.ticketQuantitiesKey(snapshot.items) ===
        this.ticketQuantitiesKey(currentItems)
      ) {
        return
      }

      const calculatedBefore = this.ticketsTotal(snapshot.items, index)
      const currentPrice = this.roundMoney(product.item.price)
      const hasTickets = (snapshot.items || []).some(
        (item) => item && item.id && Number(item.quantity) > 0
      )
      const customized =
        hasTickets && Math.abs(currentPrice - calculatedBefore) >= 0.01
      const nextPrice = this.ticketsTotal(currentItems, index)

      if (customized) {
        const productName =
          product.item.product_name ||
          (product.item.product && product.item.product.product_name) ||
          'deste item'
        const result = await swal.fire({
          title: 'Valor digitado manualmente',
          text: `O valor de "${productName}" está em ${this.formatCurrency(
            currentPrice
          )}, diferente da soma dos ingressos (${this.formatCurrency(
            calculatedBefore
          )}). Recalcular acompanha a nova quantidade e define o valor em ${this.formatCurrency(
            nextPrice
          )}. O desconto, se houver, continua sendo aplicado depois.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Recalcular valor',
          cancelButtonText: 'Voltar',
          confirmButtonClass: 'btn btn-primary',
          cancelButtonClass: 'btn btn-secondary',
          buttonsStyling: false,
          reverseButtons: true,
        })
        if (!result.isConfirmed) {
          this.restoreTicketState(index, snapshot)
          return
        }
      }

      product.item.price = nextPrice
      this.updateProductsValue(index)
    },

    // O mínimo do ingresso não altera o passo: sempre −1 ou +1.
    // O máximo continua como teto.
    ticketQuantityStep(quantity, max, direction) {
      const current = Number(quantity) || 0
      const maximum = Number(max)
      const hasMax = max != null && max !== '' && !isNaN(maximum) && maximum > 0

      if (direction > 0) {
        const next = current + 1
        if (hasMax && next > maximum) return current
        return next
      }
      if (current <= 0) return 0
      return current - 1
    },

    isTicketBelowMinimum(ticket) {
      const minimum = Number(ticket && ticket.min)
      if (!(minimum > 0)) return false
      const quantity = Number(ticket.quantity) || 0
      return quantity > 0 && quantity < minimum
    },

    applyTicketQuantity(index, item, next) {
      const current = Number(item.quantity) || 0
      if (next === current) return false
      item.quantity = next
      const people = Number(this.transaction.products[index].booking.people) || 0
      this.transaction.products[index].booking.people = Math.max(
        0,
        people + (next - current)
      )
      return true
    },

    async increaseTicketQuantity(ticket, index) {
      const snapshot = this.snapshotTicketState(ticket, index)
      let currentTicket = this.poisList.find(
        (poi) => poi.uuid == this.transaction.products[index].item.uuid
      )
      if (currentTicket) {
        currentTicket = currentTicket.tickets[ticket.id]
      } else {
        return
      }

      const unitPrice = this.resolveTicketUnitPrice(currentTicket, index)
      currentTicket.price = unitPrice
      currentTicket.unit_price = unitPrice

      const existing = this.transaction.products[index].booking.items.find(
        (item) => item.id == ticket.id
      )
      if (!existing) {
        const next = this.ticketQuantityStep(0, currentTicket.max, 1)
        currentTicket.quantity = next
        this.transaction.products[index].booking.items =
          this.transaction.products[index].booking.items.filter((item) => {
            if (item.id != '') {
              return item
            }
          })
        currentTicket.title =
          currentTicket.label +
          ' - ' +
          this.transaction.products[index].item.product.product_name

        this.transaction.products[index].booking.items.push(currentTicket)
        this.transaction.products[index].booking.people =
          (Number(this.transaction.products[index].booking.people) || 0) + next
      } else {
        this.applyTicketQuantity(
          index,
          existing,
          this.ticketQuantityStep(existing.quantity, existing.max, 1)
        )
      }
      this.syncCatalogTicketQuantity(ticket, index)
      await this.confirmTicketPriceRecalculation(index, snapshot)
      this.ensureBookingPeopleFromTickets(index)
    },

    async decreaseTicketQuantity(ticket, index) {
      const snapshot = this.snapshotTicketState(ticket, index)
      const currentTicket = this.transaction.products[index].booking.items.find(
        (item) => item.id == ticket.id
      )
      if (!currentTicket) {
        return
      }
      this.applyTicketQuantity(
        index,
        currentTicket,
        this.ticketQuantityStep(currentTicket.quantity, currentTicket.max, -1)
      )
      this.syncCatalogTicketQuantity(ticket, index)
      await this.confirmTicketPriceRecalculation(index, snapshot)
      this.ensureBookingPeopleFromTickets(index)
    },

    syncCatalogTicketQuantity(ticket, index) {
      const product = this.transaction.products[index]
      const poi = this.poisList.find((item) => item.uuid == product.item.uuid)
      const catalog = poi && poi.tickets ? poi.tickets[ticket.id] : null
      const bookingItem = (product.booking.items || []).find(
        (item) => item && item.id == ticket.id
      )
      if (catalog && bookingItem) {
        catalog.quantity = bookingItem.quantity
      }
    },

    disablePlusTicket(ticket) {
      if (ticket.quantity && ticket.quantity >= Number(ticket.max)) {
        return true
      }
      return false
    },

    disableMinusTicket(ticket) {
      return !(Number(ticket.quantity) > 0)
    },
    bookingProductName(index) {
      return this.transaction.products[index].item.product_name
        .replace('Passeio turístico - ', '')
        .replace('Experiência - ', '')
        .replace('passeio ', '')
        .replace(' (BT)', '')
    },
  },

  created() {
    this.productPoiUuids = new WeakMap()
    this.paymentAmountTouched = new WeakMap()
    this.committedPayments = new WeakSet()
    this.pendingSyncPayments = []
    this.suppressPaymentAmountTouch = 0
    this.rememberProductPois()
  },

  async mounted() {
    this.transactionHasChanged = false
    await Promise.all([
      this.fetchPOIs({
        PLACE_UUID: this.place.uuid,
        PRODUCT_UUID: '',
      }),
      this.fetchDialCodes(),
    ])
    this.defaultProductObject.booking = JSON.parse(
      JSON.stringify(this.defaultBookingObject)
    )

    if (this.transaction.general.id == null) {
      this.transaction.payments[0].readonly = true
      this.transaction.general.user = {
        uuid: this.user.uuid,
        name: this.user.name,
      }
      this.transaction.general.date = moment().format('YYYY-MM-DD')
      this.transaction.general.bill_status = this.transaction.open
        ? 'PENDING'
        : 'PAID'
    }
    this.transaction.products.forEach((product, index) => {
      this.ensureCustomerPhone(product)
      this.ensureProductBooking(product, index)

    })
    this.transaction.payments.forEach((payment, index) => {
      if (Number(payment.payment_method.index) == 0 && payment.value == 0) {
        payment.date = ''
      }
      if (!this.transaction.payments[index].payment_types) {
        this.$set(this.transaction.payments[index], 'payment_types', [])
      }
      if (
        this.transaction.payments[index].payment_link &&
        this.transaction.payments[index].payment_link.payment_types
      ) {
        this.$set(
          this.transaction.payments[index],
          'payment_types',
          JSON.parse(
            JSON.stringify(
              this.transaction.payments[index].payment_link.payment_types
            )
          )
        )
      }
      if (!this.transaction.payments[index].time) {
        let time = this.transaction.payments[index].date.split(' ')[1]
        if (!time) {
          time = ''
        }
        this.transaction.payments[index].time = time
      }
    })

    this.transaction.products.forEach((product, index) => {
      // this.updateTransactionBooking(index, false)
    })

    if (this.currentTransactionID) {
      const paymentIndexToToggle =
        this.currentTransactionID == 'last'
          ? this.transaction.payments.length - 1
          : this.transaction.payments.findIndex(
              (payment) => payment.id == this.currentTransactionID
            )
      if (paymentIndexToToggle >= 0) {
        this.togglePaymentCollapse(paymentIndexToToggle)
        await this.generateGetnetPaymentLink(paymentIndexToToggle)
      }
    }
    this.syncTransactionLabel()
    await this.settleTransactionBaseline()
  },
}
</script>

<style>
.payment-type-checks {
  display: flex;
  flex-direction: column;
}

.payment-type-checks .custom-control {
  display: block;
  margin-right: 0;
  margin-bottom: 0.35rem;
}

.payment-done-group .custom-control {
  padding-left: 3.5rem;
  min-height: 1.5rem;
  margin-left: 0;
}

.payment-done-switch,
.payment-done-switch .custom-control-label,
.payment-done-switch
  .custom-control-input:not(:disabled)
  ~ .custom-control-label::before,
.payment-done-switch
  .custom-control-input:not(:disabled)
  ~ .custom-control-label::after {
  cursor: pointer;
}

.payment-done-switch
  .custom-control-input:not(:disabled)
  ~ .custom-control-label::before {
  opacity: 1;
  pointer-events: all;
}

.payment-done-switch
  .custom-control-input:not(:disabled):not(:checked)
  ~ .custom-control-label::before {
  background-color: #c5cdd6;
  border-color: #8b95a1;
}

.payment-done-switch
  .custom-control-input:not(:disabled):checked
  ~ .custom-control-label::before {
  background-color: #22a06b;
  border-color: #22a06b;
}

.payment-done-switch
  .custom-control-input:not(:disabled)
  ~ .custom-control-label:hover::before {
  filter: brightness(0.92);
}

.booking-pre-reserve-switch,
.booking-pre-reserve-switch .custom-control-label,
.booking-pre-reserve-switch
  .custom-control-input:not(:disabled)
  ~ .custom-control-label::before,
.booking-pre-reserve-switch
  .custom-control-input:not(:disabled)
  ~ .custom-control-label::after {
  cursor: pointer;
}

.booking-pre-reserve-switch
  .custom-control-input:not(:disabled)
  ~ .custom-control-label::before {
  opacity: 1;
  pointer-events: all;
}

.booking-pre-reserve-switch
  .custom-control-input:not(:disabled):not(:checked)
  ~ .custom-control-label::before {
  background-color: #e67e22;
  border-color: #e67e22;
}

.booking-pre-reserve-switch
  .custom-control-input:not(:disabled):checked
  ~ .custom-control-label::before {
  background-color: #1a6884;
  border-color: #1a6884;
}

.booking-status-switch-row .custom-control {
  padding-left: 4rem;
  min-height: 1.5rem;
}

.transaction-booking-date.is-invalid .el-input__inner {
  border-color: #dc3545;
}

.transaction-product-fields > [class*='col'] {
  min-width: 0;
}

.transaction-product-fields .form-control,
.transaction-product-fields .custom-select {
  max-width: 100%;
}

.transaction-product-summary,
.transaction-product-subtitle,
.transaction-payment-summary {
  margin-left: -15px;
  margin-right: -15px;
}

.transaction-product-summary > [class*='col'],
.transaction-product-subtitle > [class*='col'],
.transaction-payment-summary > [class*='col'] {
  padding-left: 15px;
  padding-right: 15px;
}

.transaction-product-summary-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

@media (min-width: 992px) {
  .transaction-product-summary-meta .transaction-summary-amount,
  .transaction-product-summary-meta .transaction-summary-actions {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.transaction-summary-amount {
  min-width: 0;
}

.transaction-summary-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  flex: 0 0 auto;
}

.transaction-ticket-qty {
  min-width: 0;
}

.transaction-ticket-qty-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  min-width: 0;
}

.ticket-below-min-icon {
  color: #e67e22;
  font-size: 0.8em;
  margin-right: 0.35rem;
}

.transaction-account-info-title {
  color: #12576e;
  white-space: nowrap;
}

@media (max-width: 991.98px) {
  .transaction-product-summary,
  .transaction-payment-summary {
    flex-wrap: wrap;
  }

  .transaction-product-summary .transaction-summary-amount,
  .transaction-product-summary .transaction-summary-actions {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .transaction-ticket-qty-controls {
    justify-content: flex-start;
    margin-top: 0.25rem;
  }
}

@media (max-width: 575.98px) {
  .transaction-customer-fields > [class*='col'],
  .transaction-product-fields > [class*='col'] {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .transaction-account-info-title {
    font-size: 1.35rem;
  }
}

.discount-value-field {
  position: relative;
}

.discount-value-field > .discount-value-input,
.discount-value-field > input {
  padding-right: 2.1rem;
}

.discount-observation-toggle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  z-index: 2;
  cursor: pointer;
  line-height: 1;
}

.discount-observation-toggle .fas {
  font-size: 0.95rem;
  pointer-events: none;
}

.phone-country-prepend {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.75rem;
  padding: 0.375rem 0.7rem !important;
  cursor: pointer;
}

.input-group > .phone-number-field {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  align-self: stretch;
}

.phone-number-field > .form-control {
  width: 100%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.phone-ddi-prefix {
  position: absolute;
  z-index: 2;
  top: 1px;
  bottom: 1px;
  left: 0.75rem;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  background: transparent;
  color: #8898aa;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
}

.phone-country-flag-button {
  border: 0;
  background: transparent;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.phone-country-flag-button:disabled {
  cursor: not-allowed;
}

.phone-country-flag {
  font-size: 1.35rem;
  line-height: 1;
  pointer-events: none;
  user-select: none;
}

.phone-country-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1990;
  background: transparent;
}

.phone-country-menu {
  position: fixed;
  z-index: 2000;
  width: 16.5rem;
  max-height: 16rem;
  overflow: auto;
  background: #fff;
  border: 1px solid #d8e2e8;
  border-radius: 0.35rem;
  box-shadow: 0 8px 24px rgba(18, 87, 110, 0.15);
  padding: 0.35rem;
  text-align: left;
}

.phone-country-search {
  width: 100%;
  border: 1px solid #d8e2e8;
  border-radius: 0.25rem;
  padding: 0.3rem 0.5rem;
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
}

.phone-country-option {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 0.35rem 0.45rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.85rem;
}

.phone-country-option:hover,
.phone-country-option.is-selected {
  background: #eef5f8;
}

.phone-country-empty {
  padding: 0.4rem 0.45rem;
  color: #6c757d;
  font-size: 0.85rem;
}
</style>
